import { Component, ViewChild, ViewContainerRef, ComponentRef, Type, Injector, OnInit, OnDestroy, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'src/app/shared/shared.module';
import { TBSBaseComponent } from 'src/app/shared/models/tbsBaseComponent';
import { ProfileComponent } from 'src/app/modules/profile/profile.component';
import { FaqComponent } from 'src/app/shared/faq/faq.component';
import { ClaimMainComponent } from 'src/app/modules/claim/claim-main.component';
import { BenefitDetailsComponent } from 'src/app/shared/benefit-details/benefit-details.component';
import { BeneficiariesInfoComponent } from '../../profile/beneficiaries-info/beneficiaries-info.component';
import { ClaimDetailsModalComponent } from '../../claim/claim-details-modal/claim-details-modal.component';
import { AddEditDependentComponent } from 'src/app/shared/add-edit-dependent/add-edit-dependent.component';
import { BeneficiaryComponent } from 'src/app/shared/beneficiary/beneficiary.component';
import { AiUtilitiesService } from '../ai-utilities.service';
import { PageStyleMode } from 'src/app/shared/models/constants';
import { PersonalInfoComponent } from '../../profile/personal-info/personal-info.component';
import { ProfileService } from '../../profile/profile.service'

@Component({
  selector: 'app-ai-dynamic-template',
  imports: [RouterModule, SharedModule],
  templateUrl: './ai-dynamic-template.component.html'
})
export class AiDynamicTemplateComponent extends TBSBaseComponent implements OnInit, OnDestroy {
  @Input() formType: string = 'PersonalInfo';
  @ViewChild('dynamicHost', { read: ViewContainerRef, static: true }) dynamicHost!: ViewContainerRef;
  private componentRef?: ComponentRef<TBSBaseComponent>;
  showRelatedPathCta: boolean;
  relatedPathCtaLink: string;
  relatedFragment: string;
  dataToSend = { /* your data object */ };
  constructor(
    injector: Injector,
    private readonly aiUtilitiesService: AiUtilitiesService, private readonly profileService: ProfileService
    ,
    
  ) {
    super(injector);
  }


  loadComponent(componentType: Type<TBSBaseComponent>) {
    this.dynamicHost.clear();
    this.componentRef = this.dynamicHost.createComponent(componentType);

  }


  ngOnInit(): void {
    this.disposeRelatedPathCta();
    switch (this.formType) {
      case 'Profile':
        this.showProfile();
        break;
      case 'ClaimFlow':
        this.showClaimFlow('ec68d561-3b0c-11ed-a9a0-000d3a2adaa5');
        break;
      case 'Beneficiaries':
        this.showBeneficiaries();
        break;
      case 'BeneficiaryDetail':
        this.showBeneficiaryDetail();
        break;
      case 'BenefitCard':
        this.showBenefitCard();
        break;
      case 'Dependents':
        this.showDependentDetails();
        break;
      case 'ClaimDetails':
        this.showClaimDetails();
        break;
      case 'PersonalInfo':
          this.PersonalInfoin();
        break;
      default:
        // Optionally handle unknown types
        break;
    }
  }

  showBeneficiaries() {
    this.loadComponent(BeneficiariesInfoComponent);
    this.dataToSend = { formType: 'Beneficiaries' };
    this.enableRelatedPathCta('/profile', 'dependentsandbeneficiaries');
  }

  showBeneficiaryDetail() {
    const beneficiaries: any[] = [
      {
        "employee_RecordID": "b1d58341-5462-4f27-b8e2-0e49a517210f",
        "recordID": "e83f0e89-60c2-453c-bfb5-0e374512b66b",
        "recordEffective": "2025-09-07T00:00:00",
        "line_RecordID": "ed76c1ad-8232-4665-a527-788c958d52fe",
        "lineName": "C_Credit_Tiered Line Add On with EOI",
        "allocationBeneficiaries": [
          {
            "employeeRelationship_RecordID": "52d5f402-4a39-458b-a3ca-fb5933bb33bb",
            "beneficiaryName": "father fathe",
            "beneficiaryType": 1,
            "allocationPercentage": 100,
            "irrevocable": true,
            "recordID": "e83f0e89-60c2-453c-bfb5-0e374512b66b",
            "recordEffective": "2025-09-07T00:00:00",
            "firstName": "father",
            "lastName": "fathe",
            "legalName": null,
            "irrevocablePending": true,
            "currentAllocationPercentage": 100,
            "currentBeneficiaryType": 1,
            "trusteeFirstName": null,
            "trusteeLastName": null,
            "trusteeRelationshipType_Name": null,
            "relationshipName": "Beneficiary Father"
          }
        ],
        "beneficiariesPending": false,
        "beneficiariesRequired": false,
        "hasEvent": true,
        "collectContingentBeneficiaries": false,
        "collectIrrevocableStatus": true,
        "benefitPlan_RecordID": "66ee76b7-aae2-4d3d-94c6-5528e9b6b64b",
        "employeeEvent_RecordID": null,
        "trackAssentTimeStamp": null,
        "maxTotalBeneficiaries": null
      }
    ];
    const beneficiariesData = this.aiUtilitiesService.createBeneficiaryAllocation(beneficiaries);

    this.dynamicHost.clear();
    let component = this.dynamicHost.createComponent<BeneficiaryComponent>(BeneficiaryComponent);
    this.dataToSend = { formType: 'Beneficiaries' };
    this.enableRelatedPathCta('/profile', 'dependentsandbeneficiaries');
    this.componentRef = component as ComponentRef<BeneficiaryComponent>;
    this.componentRef.setInput('Plan', beneficiariesData[0].plan);
    this.componentRef.setInput('EmployeeBenefitID', 0);
    this.componentRef.setInput('BeneficiariesRequiredForPlan', beneficiariesData[0].beneficiariesRequired);
    this.componentRef.setInput('LineRecordId', beneficiariesData[0].line_RecordID);
    this.componentRef.setInput('LineName', beneficiariesData[0].lineName);
    this.componentRef.setInput('BeneficiariesFromProfile', {
      beneficiaryAllocation: beneficiariesData[0].lineAllocation,
      relationShipFilter: {
        EmployeeBenefitID: null,
        Line_RecordID: beneficiariesData[0].lineAllocation.line_RecordID,
        BenefitPlan_RecordID: beneficiariesData[0].plan.recordID,
        Mode_RecordID: 2
      }
    });
    this.componentRef.setInput('isFromProfile', true);
  }
  ngOnDestroy(): void {
    this.signalUnsubscribe();
  }
  showProfile() {
    this.loadComponent(ProfileComponent);
  }
  showBenefitCard() {
    this.dynamicHost.clear();
    let productJSON = { "showEmployeeAsCovered": true, "entityInformationType": { "sableInstance_RecordID": "842a7df3-4834-11f0-aa2e-000d3a24571b", "entityInstanceID": null, "dataViewInfo_RecordID": null, "responseType": 0, "isOptional": false, "allowEdit": false, "allowDelete": false }, "adjustmentType": null, "requiresFurtherAction": false, "allocationType": { "employee_RecordID": "685dae0f-1ea0-42a2-9513-ef3162264565", "recordID": "c2f3fe45-f42d-4455-917e-9a2ee24b52f8", "recordEffective": "2025-06-13T00:00:00", "line_RecordID": "28d64296-39b3-442e-8bce-9be8d2511f32", "lineName": "Local - Tiered Line With Beneficiaries Included", "allocationBeneficiaries": [{ "employeeRelationship_RecordID": "aae5c6c5-1f6f-4f12-8059-ef841583d03c", "beneficiaryName": "Spouz Lname", "beneficiaryType": 1, "allocationPercentage": 100, "irrevocable": false, "recordID": "c2f3fe45-f42d-4455-917e-9a2ee24b52f8", "recordEffective": "2025-06-13T00:00:00", "firstName": "Spouz", "lastName": "Lname", "legalName": "", "irrevocablePending": false, "currentAllocationPercentage": 100, "currentBeneficiaryType": 1, "trusteeFirstName": null, "trusteeLastName": null, "trusteeRelationshipType_Name": null, "relationshipName": "Child" }], "beneficiariesPending": false, "beneficiariesRequired": false, "hasEvent": true, "collectContingentBeneficiaries": false, "collectIrrevocableStatus": false, "benefitPlan_RecordID": "966ff7a8-f9f5-4ccd-bc0f-d4a04af5eb5b", "employeeEvent_RecordID": null, "trackAssentTimeStamp": null, "maxTotalBeneficiaries": null }, "genericDataViewType_RecordID": "00000000-0000-0000-0000-000000000000", "dataViewInfo": null, "name": "Local - Tiered Line With Beneficiaries Included", "description": "<p><strong>Display - NEW THIS YEAR</strong></p>\r\n<p>Mental health treatement up to 60 days. Up to two weeks treatment at home, Chest health screening X-ray, bi-annual Stress EKG monitoring.</p>", "footer": "", "benefitPlanStep": null, "benefitPlanName": "Plan 3", "benefitTitle": null, "benefitPlanDescription": null, "benefitPrinciple": " Self", "providerName": null, "fundedCoverLevel": "", "coverageName": "Employee Only", "employeeEvent_RecordID": "72789f5b-4834-11f0-aa2e-000d3a24571b", "recordEffective": "2025-06-13T00:00:00", "recordEffectiveEndDate": null, "employeeCost_PayPeriod": 0, "employeeProratedCost": null, "employeeCostPreTax": 0, "employerCost_PayPeriod": 0, "maximumFundedCoverage_Amount": null, "recordSequence": 292454, "line_RecordID": "28d64296-39b3-442e-8bce-9be8d2511f32", "lineSet_RecordID": "00000000-0000-0000-0000-000000000000", "lineSet_Name": null, "voucherGroup_RecordID": null, "voucherGroup_Name": null, "line_DisplayOrder": 4, "calculatedVolume": 70, "employeeVolume": 70, "employerVolume": 0, "amountType": "Not Specified", "amountTypeCaption": "", "benefitPlan_RecordID": "966ff7a8-f9f5-4ccd-bc0f-d4a04af5eb5b", "isSinglePurchasePerParticipant": false, "singleParticipantOnly": false, "baselineBenefit": { "showEmployeeAsCovered": true, "entityInformationType": { "sableInstance_RecordID": "842a7df3-4834-11f0-aa2e-000d3a24571b", "entityInstanceID": null, "dataViewInfo_RecordID": null, "responseType": 0, "isOptional": false, "allowEdit": false, "allowDelete": false }, "adjustmentType": null, "requiresFurtherAction": false, "allocationType": { "employee_RecordID": "685dae0f-1ea0-42a2-9513-ef3162264565", "recordID": "c2f3fe45-f42d-4455-917e-9a2ee24b52f8", "recordEffective": "2025-06-13T00:00:00", "line_RecordID": "28d64296-39b3-442e-8bce-9be8d2511f32", "lineName": "Local - Tiered Line With Beneficiaries Included", "allocationBeneficiaries": [{ "employeeRelationship_RecordID": "aae5c6c5-1f6f-4f12-8059-ef841583d03c", "beneficiaryName": "Spouz Lname", "beneficiaryType": 1, "allocationPercentage": 100, "irrevocable": false, "recordID": "c2f3fe45-f42d-4455-917e-9a2ee24b52f8", "recordEffective": "2025-06-13T00:00:00", "firstName": "Spouz", "lastName": "Lname", "legalName": "", "irrevocablePending": false, "currentAllocationPercentage": 100, "currentBeneficiaryType": 1, "trusteeFirstName": null, "trusteeLastName": null, "trusteeRelationshipType_Name": null, "relationshipName": "Child" }], "beneficiariesPending": false, "beneficiariesRequired": false, "hasEvent": true, "collectContingentBeneficiaries": false, "collectIrrevocableStatus": false, "benefitPlan_RecordID": "966ff7a8-f9f5-4ccd-bc0f-d4a04af5eb5b", "employeeEvent_RecordID": null, "trackAssentTimeStamp": null, "maxTotalBeneficiaries": null }, "genericDataViewType_RecordID": "00000000-0000-0000-0000-000000000000", "dataViewInfo": null, "name": "Local - Tiered Line With Beneficiaries Included", "description": "<p><strong>Display - NEW THIS YEAR</strong></p>\r\n<p>Mental health treatement up to 60 days. Up to two weeks treatment at home, Chest health screening X-ray, bi-annual Stress EKG monitoring.</p>", "footer": "", "benefitPlanStep": null, "benefitPlanName": "Plan 3", "benefitTitle": null, "benefitPlanDescription": null, "benefitPrinciple": " Self", "providerName": null, "fundedCoverLevel": "", "coverageName": "Employee Only", "employeeEvent_RecordID": "72789f5b-4834-11f0-aa2e-000d3a24571b", "recordEffective": "2025-06-13T00:00:00", "recordEffectiveEndDate": null, "employeeCost_PayPeriod": 0, "employeeProratedCost": null, "employeeCostPreTax": 0, "employerCost_PayPeriod": 0, "maximumFundedCoverage_Amount": null, "recordSequence": 292454, "line_RecordID": "28d64296-39b3-442e-8bce-9be8d2511f32", "lineSet_RecordID": "00000000-0000-0000-0000-000000000000", "lineSet_Name": null, "voucherGroup_RecordID": null, "voucherGroup_Name": null, "line_DisplayOrder": 4, "calculatedVolume": 70, "employeeVolume": 70, "employerVolume": 0, "amountType": "Not Specified", "amountTypeCaption": "", "benefitPlan_RecordID": "966ff7a8-f9f5-4ccd-bc0f-d4a04af5eb5b", "isSinglePurchasePerParticipant": false, "singleParticipantOnly": false, "baselineBenefit": null, "coveredDependants": [{ "firstName": "SowjanyaOctRelz", "middleName": "", "lastName": "OctRelZ", "legalName": null, "relationshipType_Name": "Self", "lookupRelationshipType_RecordID": 0, "futureDeletedDate": null }], "eoiInformation": null, "currencySymbol": "Rps", "currencyCode": "INR", "usesAlternateCalculationRelationship": false, "recordID": "8a35cf46-4834-11f0-aa2e-000d3a24571b", "question1": null, "question2": null, "question3": null, "question1AnswerLabel": "", "question2AnswerLabel": "", "question3AnswerLabel": "", "lineDisplayQuestion_RecordID": null, "isNoCoverage": false, "hideEmployerCost": false, "hideEmployeeCost": false, "hideNoCoverElection": false, "employeeCost_Annual": 0, "employeeProratedAnnualCost": null, "employeeAnnualCostPreTax": 0, "employerCost_Annual": 0, "hideOnSite": false, "amountType_RecordID": 0, "customAmountTypeValue": null, "totalCost_PayPeriod": 0, "creditsApplied": 0, "annualCreditsApplied": 0, "lockoutText": null, "showLockoutText": false, "lockoutEndDate": null, "lookupLineType_RecordID": 1, "employeePoints": 0, "employeeAnnualPoints": 0, "employeeElectionFundAllocations": [], "isPointsUsed": false, "appliedLeftOverCredit": null, "appliedLeftOverCreditPoints": null, "usesDeductionCapacity": false, "hideOnCostToYou": false, "hideOnEnrolmentStep3": false, "alwaysIncludeInCostToYou": false, "excludeFromAnnualPayPeriodToggle": false, "alwaysIncludeInSummary": true, "hideCoverageVolume": false, "isNetCostUsed": false, "canInteract": false, "canBeneficiaryInteract": false, "employeeNetCost": 0, "employeeNetAnnualCost": 0, "employerNetCost": 0, "employerNetAnnualCost": 0, "taxability": false, "marketValueAnnualCost": null, "marketValuePayPeriodCost": null, "taxInfo": null, "employeeElectionFollowUpItems": [], "employeeElectionAdditionalDatas": [], "electionPcp": null, "hasDependantDeferralOrEOI": false, "actualAnnualEmployeeCost": null, "actualAnnualEmployerCost": null, "actualAnnualEmployeeOnlyCost": null, "actualAnnualEmployerOnlyCost": null, "coolOffPeriodExpirationDate": null, "renewalDate": null, "canBeRenewed": false, "renewalErrorMessage": null, "isAutoRenewal": false, "isRenewalComplete": false, "inCoolOffPeriod": false, "cancellationEffectiveDate": "2025-06-13T00:00:00", "isCovCollectedPerMemberIndependently": false, "dependantOnlyCoverage": false, "applicationReferenceNumber": null, "brokeredPolicy_RecordID": null, "employeeBenefitID": 73548, "employeePolicyPremium_RecordID": null, "isExternalValidationFailed": false, "errorMessage": null, "warningMessage": null, "costType": { "dependant_RecordID": null, "calculated_EmployeeCost": 0, "calculated_EmployeeCostPreTax": 0, "calculated_EmployerCost": 0, "calculated_EmployeeCostTotal": 0, "calculated_EmployeeCost_Annual": 0, "calculated_EmployeeCostPreTax_Annual": 0, "calculated_EmployerCost_Annual": 0, "calculated_EmployeeCostTotal_Annual": 0, "calculated_EmployeePEC": 0, "calculated_EmployerPEC": 0, "isSelected": true, "canBeRemovedFromCoverage": false, "selectedEEPayPeriodCost": 0, "selectedEEAnnualCost": 0, "selectedEEPayPeriodCostPreTax": 0, "selectedEEAnnualCostPreTax": 0, "selectedERPayPeriodCost": 0, "selectedERAnnualCost": 0, "calculated_EmployeeNetCost": 0, "calculated_EmployerNetCost": 0, "calculated_EmployeeNetCostTotal": 0, "calculated_EmployeeNetCost_Annual": 0, "calculated_EmployerNetCost_Annual": 0, "calculated_EmployeeNetCostTotal_Annual": 0, "selectedEENetPayPeriodCost": 0, "selectedEENetAnnualCost": 0, "selectedERNetPayPeriodCost": 0, "selectedERNetAnnualCost": 0, "captureUserAmount": false, "maximumAmount": null, "minimumAmount": null, "increment": null, "amount": null, "amount2": null, "amountType_RecordID": 0, "amountType": null, "customAmountTypeValue": null, "amountTypeCaption": null, "calculated_Volume": null, "zeroInputType": 0, "valueListLabel": null, "valueListValue": null, "valueListValue_RecordID": null, "valueListValueRate_RecordID": null, "dependantCoverageEOIInformation": null, "isEOI": false, "costEOIType": null, "coverage_RecordID": "00000000-0000-0000-0000-000000000000", "benefitPlan_RecordID": "00000000-0000-0000-0000-000000000000", "coverageName": null, "benefitPlanName": null, "isLocked": false, "adjustment_EmployeeCost": null, "adjustment_EmployerCost": null }, "addOnGroups": null, "dependantElections": null, "isActiveEnrollmentRequired": false, "isActiveEnrollmentComplete": true, "coverageStartDate": "2025-06-13T00:00:00", "coverageEndDate": null, "annualSpend": null, "policy_RecordID": null, "policyDisplayName": null, "taxes": [], "canApplyCredits": false, "lookupEmployeeEventStatus_RecordID": 3, "lineGivenAnswers": [], "eoiGivenAnswers": null, "payFrequency_RecordID": 0, "payFrequency_Caption": null, "payFrequencyText": null, "linePayFrequencyTypes": null, "employeePolicyNumber": null, "employeePolicyStartDate": null, "isInRenewalPeriod": false, "isInGracePeriodRenewal": false, "paymentScheduleType": null, "canEdit": true, "canCancel": true, "canUndoCancel": false, "canExtendRenewalGracePeriod": false, "gracePeriodRenewalDate": null, "minRenewalGracePeriodEndDate": null, "isCancelled": false, "failedPayment": null, "employeeBenefit_CreatedOn": "2025-06-13T16:57:35.513", "supportsParallel": false, "lineCarrier_RecordID": null, "sableSummaries": [], "totalCost_Annual": 0, "totalCost_Today": 0, "sableFlow_RecordID": "69ffca36-4b85-11ec-a994-000d3a2adaa5", "parent_EmployeeSableFlowInstance_RecordID": "7ce18a8a-4834-11f0-aa2e-000d3a24571b", "sableActivity_RecordID": "23aa20a6-6945-11ec-a995-000d3a2adaa5", "daysToRetainQuotes": 30, "daysOnQuote": 82, "requiresRecalc": false, "supportsCheckout": false, "previous_EmployeeBenefitID": null, "referenceOnly": false, "suppressRelationshipOnReview": null, "hideWhosCoveredOnReview": null, "canDiscard": true, "showEffectiveDateOnEndReview": false, "anytimeEntityInformationType": null, "valueSummary": null, "gaTag": "Plan 3", "policiesCount": null, "allocationBeneficiariesCount": null, "allCoveredDependantsCount": null, "addOnsValueSummaries": null, "employeeCostLabel": null, "employerCostLabel": null, "employeeAdjustedCostLabel": null, "employerAdjustedCostLabel": null, "totalCostLabel": null, "userChange": { "isDeleted": false }, "defaultedChange": { "isNew": false, "isDeleted": false, "costChanged": false, "dependantChanged": false, "planChanged": false }, "canDeselect": false, "paymentDeferred": false, "paymentSources": null, "fundingRelease_PayPeriod": null, "fundingRelease_Annual": null, "fundingReleaseLabel": null, "fundingForfeiture_PayPeriod": null, "fundingForfeiture_Annual": null, "fundingForfeitureLabel": null, "fullEmployeeCost_PayPeriod": 0, "fullEmployeeCost_Annual": 0, "outstanding_PayPeriod": null, "outstanding_Annual": null, "allowPartialAllocations": false, "employeePayPeriodTaxTotalAmount": 0, "employerPayPeriodTaxTotalAmount": 0, "employeeAnnualTaxTotalAmount": 0, "employerAnnualTaxTotalAmount": 0, "fundedCoverage_PayPeriod": 0, "fundedCoverage_Annual": 0, "employeeQuote_RecordID": null, "actualPeriodCost_EmployeeCost": null, "actualPeriodCost_EmployerCost": null, "hideAddonDetailsOnBenefitCard": false, "costSchedules": null }, "coveredDependants": [{ "firstName": "SowjanyaOctRelz", "middleName": "", "lastName": "OctRelZ", "legalName": null, "relationshipType_Name": "Self", "lookupRelationshipType_RecordID": 0, "futureDeletedDate": null }], "eoiInformation": null, "currencySymbol": "Rps", "currencyCode": "INR", "usesAlternateCalculationRelationship": false, "recordID": "8a35cf46-4834-11f0-aa2e-000d3a24571b", "question1": null, "question2": null, "question3": null, "question1AnswerLabel": "", "question2AnswerLabel": "", "question3AnswerLabel": "", "lineDisplayQuestion_RecordID": null, "isNoCoverage": false, "hideEmployerCost": false, "hideEmployeeCost": false, "hideNoCoverElection": false, "employeeCost_Annual": 0, "employeeProratedAnnualCost": null, "employeeAnnualCostPreTax": 0, "employerCost_Annual": 0, "hideOnSite": false, "amountType_RecordID": 0, "customAmountTypeValue": null, "totalCost_PayPeriod": 0, "creditsApplied": 0, "annualCreditsApplied": 0, "lockoutText": null, "showLockoutText": false, "lockoutEndDate": null, "lookupLineType_RecordID": 1, "employeePoints": 0, "employeeAnnualPoints": 0, "employeeElectionFundAllocations": [], "isPointsUsed": false, "appliedLeftOverCredit": null, "appliedLeftOverCreditPoints": null, "usesDeductionCapacity": false, "hideOnCostToYou": false, "hideOnEnrolmentStep3": false, "alwaysIncludeInCostToYou": false, "excludeFromAnnualPayPeriodToggle": false, "alwaysIncludeInSummary": true, "hideCoverageVolume": false, "isNetCostUsed": false, "canInteract": false, "canBeneficiaryInteract": false, "employeeNetCost": 0, "employeeNetAnnualCost": 0, "employerNetCost": 0, "employerNetAnnualCost": 0, "taxability": false, "marketValueAnnualCost": null, "marketValuePayPeriodCost": null, "taxInfo": null, "employeeElectionFollowUpItems": [], "employeeElectionAdditionalDatas": [], "electionPcp": null, "hasDependantDeferralOrEOI": false, "actualAnnualEmployeeCost": null, "actualAnnualEmployerCost": null, "actualAnnualEmployeeOnlyCost": null, "actualAnnualEmployerOnlyCost": null, "coolOffPeriodExpirationDate": null, "renewalDate": null, "canBeRenewed": false, "renewalErrorMessage": null, "isAutoRenewal": false, "isRenewalComplete": false, "inCoolOffPeriod": false, "cancellationEffectiveDate": "2025-06-13T00:00:00", "isCovCollectedPerMemberIndependently": false, "dependantOnlyCoverage": false, "applicationReferenceNumber": null, "brokeredPolicy_RecordID": null, "employeeBenefitID": 73548, "employeePolicyPremium_RecordID": null, "isExternalValidationFailed": false, "errorMessage": null, "warningMessage": null, "costType": { "dependant_RecordID": null, "calculated_EmployeeCost": 0, "calculated_EmployeeCostPreTax": 0, "calculated_EmployerCost": 0, "calculated_EmployeeCostTotal": 0, "calculated_EmployeeCost_Annual": 0, "calculated_EmployeeCostPreTax_Annual": 0, "calculated_EmployerCost_Annual": 0, "calculated_EmployeeCostTotal_Annual": 0, "calculated_EmployeePEC": 0, "calculated_EmployerPEC": 0, "isSelected": true, "canBeRemovedFromCoverage": false, "selectedEEPayPeriodCost": 0, "selectedEEAnnualCost": 0, "selectedEEPayPeriodCostPreTax": 0, "selectedEEAnnualCostPreTax": 0, "selectedERPayPeriodCost": 0, "selectedERAnnualCost": 0, "calculated_EmployeeNetCost": 0, "calculated_EmployerNetCost": 0, "calculated_EmployeeNetCostTotal": 0, "calculated_EmployeeNetCost_Annual": 0, "calculated_EmployerNetCost_Annual": 0, "calculated_EmployeeNetCostTotal_Annual": 0, "selectedEENetPayPeriodCost": 0, "selectedEENetAnnualCost": 0, "selectedERNetPayPeriodCost": 0, "selectedERNetAnnualCost": 0, "captureUserAmount": false, "maximumAmount": null, "minimumAmount": null, "increment": null, "amount": null, "amount2": null, "amountType_RecordID": 0, "amountType": null, "customAmountTypeValue": null, "amountTypeCaption": null, "calculated_Volume": null, "zeroInputType": 0, "valueListLabel": null, "valueListValue": null, "valueListValue_RecordID": null, "valueListValueRate_RecordID": null, "dependantCoverageEOIInformation": null, "isEOI": false, "costEOIType": null, "coverage_RecordID": "00000000-0000-0000-0000-000000000000", "benefitPlan_RecordID": "00000000-0000-0000-0000-000000000000", "coverageName": null, "benefitPlanName": null, "isLocked": false, "adjustment_EmployeeCost": null, "adjustment_EmployerCost": null }, "addOnGroups": null, "dependantElections": null, "isActiveEnrollmentRequired": false, "isActiveEnrollmentComplete": true, "coverageStartDate": "2025-06-13T00:00:00", "coverageEndDate": null, "annualSpend": null, "policy_RecordID": null, "policyDisplayName": null, "taxes": [], "canApplyCredits": false, "lookupEmployeeEventStatus_RecordID": 3, "lineGivenAnswers": [], "eoiGivenAnswers": null, "payFrequency_RecordID": 0, "payFrequency_Caption": null, "payFrequencyText": null, "linePayFrequencyTypes": null, "employeePolicyNumber": null, "employeePolicyStartDate": null, "isInRenewalPeriod": false, "isInGracePeriodRenewal": false, "paymentScheduleType": null, "canEdit": true, "canCancel": true, "canUndoCancel": false, "canExtendRenewalGracePeriod": false, "gracePeriodRenewalDate": null, "minRenewalGracePeriodEndDate": null, "isCancelled": false, "failedPayment": null, "employeeBenefit_CreatedOn": "2025-06-13T16:57:35.513", "supportsParallel": false, "lineCarrier_RecordID": null, "sableSummaries": [], "totalCost_Annual": 0, "totalCost_Today": 0, "sableFlow_RecordID": "69ffca36-4b85-11ec-a994-000d3a2adaa5", "parent_EmployeeSableFlowInstance_RecordID": "7ce18a8a-4834-11f0-aa2e-000d3a24571b", "sableActivity_RecordID": "23aa20a6-6945-11ec-a995-000d3a2adaa5", "daysToRetainQuotes": 30, "daysOnQuote": 82, "requiresRecalc": false, "supportsCheckout": false, "previous_EmployeeBenefitID": null, "referenceOnly": false, "suppressRelationshipOnReview": null, "hideWhosCoveredOnReview": null, "canDiscard": true, "showEffectiveDateOnEndReview": false, "anytimeEntityInformationType": null, "valueSummary": null, "gaTag": "Plan 3", "policiesCount": null, "allocationBeneficiariesCount": null, "allCoveredDependantsCount": null, "addOnsValueSummaries": null, "employeeCostLabel": null, "employerCostLabel": null, "employeeAdjustedCostLabel": null, "employerAdjustedCostLabel": null, "totalCostLabel": null, "userChange": { "isDeleted": false }, "defaultedChange": { "isNew": false, "isDeleted": false, "costChanged": false, "dependantChanged": false, "planChanged": false }, "canDeselect": false, "paymentDeferred": false, "paymentSources": null, "fundingRelease_PayPeriod": null, "fundingRelease_Annual": null, "fundingReleaseLabel": null, "fundingForfeiture_PayPeriod": null, "fundingForfeiture_Annual": null, "fundingForfeitureLabel": null, "fullEmployeeCost_PayPeriod": 0, "fullEmployeeCost_Annual": 0, "outstanding_PayPeriod": null, "outstanding_Annual": null, "allowPartialAllocations": false, "employeePayPeriodTaxTotalAmount": 0, "employerPayPeriodTaxTotalAmount": 0, "employeeAnnualTaxTotalAmount": 0, "employerAnnualTaxTotalAmount": 0, "fundedCoverage_PayPeriod": 0, "fundedCoverage_Annual": 0, "employeeQuote_RecordID": null, "actualPeriodCost_EmployeeCost": null, "actualPeriodCost_EmployerCost": null, "hideAddonDetailsOnBenefitCard": false, "costSchedules": null };
    let product = JSON.parse(JSON.stringify(productJSON));
    let component = this.dynamicHost.createComponent<BenefitDetailsComponent>(BenefitDetailsComponent);
    component.instance.isPerPay = true;
    component.instance.product = product;
    component.instance.isMultiInstance = false;
    component.instance.showBuildPolicyButton = false;
    component.instance.index = 0;
    component.instance.isProfileDisplay = true;
    component.instance.displayERCostAsFunding = true;
    component.instance.transformNegativeEmployeeCost = product.transformNegativeEmployeeCost;
    this.enableRelatedPathCta('/profile', 'activebenefits');
    this.componentRef = component;

  }
  showFaq() {
    this.loadComponent(FaqComponent);
  }
  showClaimFlow(claimId: string) {
    this.dynamicHost.clear();
    let component = this.dynamicHost.createComponent<ClaimMainComponent>(ClaimMainComponent);
    //component.instance.inAiChatWindow = true;
    component.instance.flowID = claimId;
    component.instance.instanceid = 'd547600d-8313-11f0-aa33-000d3a24571b';
    this.componentRef = component;
  }
  showClaimDetails() {
    this.dynamicHost.clear();
    let claimItemJSON = {
      "recordID": "ecec3109-87c0-47a8-8535-0f031dbb33fd",
      "tenant": "Next Gen OLB",
      "employeeNumberID": "676876",
      "employeeBusinessUnit": "",
      "employeeName": "SowjanyaOctRelz OctRelZ",
      "claimNumber": 586,
      "claimNumberPrefix": "#",
      "claimSubItem": null,
      "claimantName": "SowjanyaOctRelz OctRelZ",
      "receiptNumber": "655445",
      "receiptTaxAmount": 0,
      "clinic": "Clinic 1",
      "additionalInfo": "test A",
      "localizedStatus": null,
      "statusReason": null,
      "statusDate": "2025-05-23T00:00:00",
      "submissionDate": "2025-05-23T00:00:00",
      "paymentDate": null,
      "paymentMethod": "Interbank",
      "paymentStatus": "Processing",
      "allowUpdate": true,
      "isMedicalClaim": true,
      "attachments": [
        {
          "entity_RecordID": "ecec3109-87c0-47a8-8535-0f031dbb33fd",
          "entity_Type": 1,
          "document_RecordID": "36b15933-5213-4da9-a6e8-222a915b24e0",
          "document_MIMEType": "application/pdf",
          "document_File_Name": "Active Benefits (2).pdf",
          "document_File_Ext": ".pdf",
          "document_File_Length": 47254,
          "document_File": "",
          "claimDocumentType_RecordID": "12be484d-e7eb-402e-bb20-51ab2d92b320",
          "claimDocumentType_Name": "Receipt",
          "createdOn": "2025-05-23T13:40:12.193"
        },
        {
          "entity_RecordID": "ecec3109-87c0-47a8-8535-0f031dbb33fd",
          "entity_Type": 1,
          "document_RecordID": "b2ca8b05-73d7-405e-a212-56349657d2ef",
          "document_MIMEType": "application/pdf",
          "document_File_Name": "K7Benefit.pdf",
          "document_File_Ext": ".pdf",
          "document_File_Length": 101192,
          "document_File": "",
          "claimDocumentType_RecordID": "1226cf53-561d-4d90-a5f7-7dd65557aead",
          "claimDocumentType_Name": "Aadhar",
          "createdOn": "2025-05-23T13:40:12.177"
        }
      ],
      "expenseCause": "Expense Cause 1",
      "providerType": "Provider Type 1",
      "employeeClaimPaymentSource_RecordID": "3cb5c002-25c2-11f0-a9b2-000d3a44754b",
      "collectItemBreakdown": true,
      "employeeClaimItemBreakdowns": [
        {
          "recordID": "ba0257ea-04d7-4233-8a31-03b9bb550b01",
          "name": "Item AA",
          "amount": 25,
          "claimItemBreakdown_RecordID": "26fb6ad0-3fdf-45dc-a2c7-32257c68dbef"
        },
        {
          "recordID": "8df0bd9b-2822-4d23-977e-34c6490d3cb7",
          "name": "Item BB",
          "amount": 25,
          "claimItemBreakdown_RecordID": "0a2b1b69-90f7-42a9-ab26-d8b87d3afbe3"
        }
      ],
      "employeeFirstName": "SowjanyaOctRelz",
      "employeeLastName": "OctRelZ",
      "employeeLegalName": null,
      "employeePreferredName": "",
      "claimantFirstName": "SowjanyaOctRelz",
      "claimantLastName": "OctRelZ",
      "claimantLegalName": null,
      "claimantPreferredName": "",
      "isEmployeeSelfClaimant": true,
      "approvedReason": null,
      "relationshipName": "Self",
      "employeeSableFlowInstance_RecordID": "43129aee-37db-11f0-aa2b-000d3a24571b",
      "taxID": null,
      "providerTaxID": null,
      "lookupFlexClaimType_RecordID": 2,
      "claimItem": "ClaimMayRel",
      "claimType": "Medical",
      "receiptDate": "2025-05-22T00:00:00",
      "receiptAmount": 50,
      "receiptCurrency": "INR",
      "receiptCurrencySymbol": "Rps",
      "status": "Pending",
      "claimableAmount": 50,
      "claimableCurrency": "INR",
      "claimableCurrencySymbol": "Rps",
      "lookupFlexClaimStatus_RecordID": 1
    }
    let claimItem = JSON.parse(JSON.stringify(claimItemJSON));
    let component = this.dynamicHost.createComponent<ClaimDetailsModalComponent>(ClaimDetailsModalComponent);
    component.instance.claimDetailsData = claimItem;
    component.instance.isWallet = true;
    component.instance.fromAIChat = true;
    component.instance.claimSableParameter = { claimSableFlow_RecordID: 'ec68d561-3b0c-11ed-a9a0-000d3a2adaa5', editAction_SableActivity_RecordID: 'ef9734e8-6348-11ed-a9a4-000d3a2adaa5' };
    this.enableRelatedPathCta('/claim/claim-summary', '');
    this.componentRef = component;
  }

  disposeRelatedPathCta() {
    this.showRelatedPathCta = false;
    this.relatedPathCtaLink = '';
    this.relatedFragment = '';
  }
  enableRelatedPathCta(linkPath: string, fragment: string = '') {
    this.showRelatedPathCta = true;
    this.relatedPathCtaLink = linkPath;
    this.relatedFragment = fragment;
  }

  showDependentDetails() {
    this.dynamicHost.clear();
    let component = this.dynamicHost.createComponent<AddEditDependentComponent>(AddEditDependentComponent);
    component.instance.currentDependant = {
      "recordID": "57a4a5c1-bb98-4919-8505-2737d2980caf",
      "firstName": "Spouse",
      "middleName": "",
      "lastName": "Abc",
      "lastName2": "",
      "nationalID": "",
      "relationship_RecordID": "a210a358-d35c-494a-bf68-d269e5210d62",
      "relationshipType_RecordID": 1,
      "relationshipType_Name": "Spouse/Partner",
      "employeeRelationshipType_RecordID": 1,
      "employeeRelationshipType_Name": "Dependant",
      "lookupGender_RecordID": 1,
      "lookupTitle_RecordID": null,
      "lookupMaritalStatus_RecordID": 0,
      "gender": "Non Binary",
      "dob": "2025-01-01T00:00:00",
      "isFullTimeStudent": false,
      "residesWithEmployee": true,
      "employee_RecordID": "00000000-0000-0000-0000-000000000000",
      "isEligibleForPlan": true,
      "isCurrentlyCoveredForPlan": false,
      "canBeRemovedFromCoverage": true,
      "recordEffective": "2025-06-13T00:00:00",
      "homeAddress1": "",
      "homeAddress2": "",
      "homeAddress3": "",
      "homeAddress4": null,
      "homeAddress5": null,
      "homeAddress6": null,
      "homeCity": "",
      "homeStateProvince": "",
      "homePostalCode": "",
      "homeCountry_RecordID": "00000000-0000-0000-0000-000000000000",
      "homeCountry": null,
      "alternateCountry": null,
      "alternateStreetAddress1": null,
      "alternateStreetAddress2": null,
      "alternateStreetAddress3": null,
      "alternateCity": null,
      "alternateStateProvince": null,
      "alternatePostalCode": null,
      "alternateStreetAddress4": null,
      "alternateStreetAddress5": null,
      "alternateStreetAddress6": null,
      "alternateCountry_RecordID": "00000000-0000-0000-0000-000000000000",
      "dom": "2024-12-01T00:00:00",
      "dateOfDivorce": null,
      "dod": null,
      "isMedicareEligible": false,
      "isSmoker": null,
      "isDisabled": false,
      "isEmployed": false,
      "qmcso": false,
      "isAddressHidden": false,
      "isChildOfDomesticPartner": false,
      "lookUpState_RecordID": null,
      "lookUpState_Name": null,
      "lookUpAlternateState_RecordID": null,
      "lookUpAlternateState_Name": null,
      "firstName_LC1": null,
      "firstName_LC2": null,
      "middleName_LC1": null,
      "middleName_LC2": null,
      "lastName_LC1": null,
      "lastName_LC2": null,
      "lastName2_LC1": null,
      "lastName2_LC2": null,
      "legalName": "",
      "passportID": null,
      "taxID": null,
      "salary": null,
      "salaryFrequency": null,
      "salaryFrequency_Name": null,
      "salaryCurrency_RecordID": null,
      "salaryCurrency_Symbol": null,
      "citizenCountry_LookupCountry_RecordID": null,
      "citizenCountry": null,
      "isTaxDependent": null,
      "relationshipSequence_Conversion": 3,
      "miscCurrency1": null,
      "miscCurrency1Frequency": null,
      "miscCurrency1Frequency_Name": null,
      "miscCurrency1Currency_RecordID": null,
      "miscCurrency1Currency_Symbol": null,
      "miscCurrency2": null,
      "miscCurrency2Frequency": null,
      "miscCurrency2Frequency_Name": null,
      "miscCurrency2Currency_RecordID": null,
      "miscCurrency2Currency_Symbol": null,
      "miscCurrency3": null,
      "miscCurrency3Frequency": null,
      "miscCurrency3Frequency_Name": null,
      "miscCurrency3Currency_RecordID": null,
      "miscCurrency3Currency_Symbol": null,
      "miscDate1": null,
      "miscDate2": null,
      "miscDate3": null,
      "miscText1": null,
      "miscText2": null,
      "miscText3": null,
      "miscText4": null,
      "miscText5": null,
      "cpfNumber": null,
      "motherName": null,
      "nationalHealthID": null,
      "birthStatementID": null,
      "relationshipDemographic_RecordID": "72789f4c-4834-11f0-aa2e-000d3a24571b",
      "isCovered": false,
      "canEditDOB": true,
      "canEditGender": true,
      "canEditRelationship": true,
      "canEditResidesWithEmployee": true,
      "canEditIsFullTimeStudent": true,
      "canEditCountryOfBirth": true,
      "canHideEmployee": false,
      "fiscalID": null,
      "disabilityPercent": 0,
      "financialDependant": false,
      "lookupNationalIDType_RecordID": "504be25e-fd26-4370-94f0-483bf1b7a01c",
      "lookupNationalIDType_Name": "India - Aadhaar",
      "hasAppliedCreditsPointsOnCost": false,
      "personalEmail": "",
      "homeMobile": "",
      "countryOfBirth_RecordID": null,
      "countryOfBirth": "",
      "canEditNationalID": true,
      "alreadyPurchased": false,
      "alreadyIncludedInPendingPurchase": false,
      "alreadyPurchasedEmployeeBenefitID": null,
      "consentProvided": false,
      "includeMelded": null,
      "benefitCoverTitle": null,
      "relationshipRemoveReason_RecordID": null,
      "useAlternateAddress": null,
      "isEmployeeCreated": false,
      "futureDeletedDate": null,
      "workEmail": null,
      "canEditIsDisabled": true,
      "canEditIsEmployed": true,
      "canEditIsMedicareEligible": true,
      "canEditDateOfDeath": false,
      "canEditDateOfDivorce": false,
      "homeEmailPreferred": false,
      "hasIrrevocableAllocations": false,
      "trusteeFirstName": null,
      "trusteeLastName": null,
      "trusteeRelationship_RecordID": null,
      "trusteeRelationshipType_Name": null,
      "canEditNationalIDType": true,
      "isLocked": false,
      "dateOfAdoption": null,
      "canEditDateOfAdoption": false
    };
    component.instance.context = 'profile';
    component.instance.isPartial = false;
    component.instance.isEditing = false;
    component.instance.isPageStyle = PageStyleMode.DepInfo;
    component.instance.isProfile = true;
    component.instance.fromAIChat = true;
    this.enableRelatedPathCta('/profile', 'dependentsandbeneficiaries');
    this.componentRef = component;
  }

  PersonalInfoin() {
    this.dynamicHost.clear();
    let component = this.dynamicHost.createComponent<PersonalInfoComponent>(PersonalInfoComponent);
    
    component.instance.uiConfig = {
      "id": 48,
      "uiConfiguration": {
        "checkFirstTimeUser": true,
        "enableTestEmails": true,
        "testEmailAddress": "sowjanya.muralidhar@aon.com",
        "enableInputTextValidation": false,
        "inputTextRegex1": "",
        "inputTextRegex2": "",
        "enablePhoneNumberValidation": false,
        "inputPhoneNumberRegex": "",
        "enableFirstTimeUser": true,
        "enablePrivacyPolicyAcceptance": true,
        "customPrivacyPolicyTargetURL": "",
        "enableTermsAcceptance": true,
        "enableCollectOtherInfo": false,
        "enableCollectIvrInfo" : false,
        "disableIvrPhoneEdit": false,
        "enableSensitiveDataScreeningControl": true,
        "showBeneficiaryDisclaimerOnAllocationsForm": true,
        "enableMFAPrivacyConsentCollection": true,
        "enableInbox": true,
        "hideDeleteButtonInInboxGrid": false,
        "collectOtherInfoForFirstTimeUser": false,
        "userOtherInfoFormID": "93fd22ee-5edc-464c-857c-64316f29ff46",
        "showParticipantDemographicForEmployeeSelf": false,
        "enforceAtLeastOneEmailAddress": false,
        "enableDobForForgetPassword": true,
        "showForgotUsernameLinkonLoginPage": true,
        "enableWorkEmailForForgetPassword": true,
        "enableExternalLoginPage": false,
        "externalLoginPath": "",
        "enableCustomLoggedOffPage": false,
        "customLoggedOffPagePath": "",
        "displayCostsAsPoints": false,
        "pointsLabel": "Pts",
        "overrideCurrencySetting": false,
        "customCurrencySymbol": "$",
        "customCurrencyCode": "USD",
        "showCurrencyCodeInsteadOfSymbol": false,
        "roundingRuleForCurrency": "nearest",
        "roundToForCurrency": "twodigit",
        "overrideCurrencyCultureOption": "en-US",
        "nameDisplay" : "",
        "addressDisplay": "",
        "hideBenefitMenu": false,
        "italicizeClientBrandNameInMasthead": false,
        "showAISpawnControl": true,
        "showSkinnyFooter": true,
        "showLightFooter": false,
        "showFullWidthCopyrightText": false,
        "hideLogo": false,
        "hideHelp": false,
        "hideFAQ": true,
        "hideProducts": false,
        "sableFormFieldDecoration": "694272de-b57e-cba1-4d12-17022504729d",
        "positionOfExploreMoreBenefits": 1,
        "hideBreadcrumb": false,
        "pemUserInfoFlowID": "",
        "pemUserInfoLineID": "",
        "setWrapperPage": false,
        "replaceHomeWithWrapperPage": false,
        "showHeroCTAs": true,
        "showEnrollmentEventInformationHero": false,
        "hideProductsInhero": true,
        "showHomeWidgets": true,
        "hideProductsListInHome": false,
        "hideFaqInHome": false,
        "showSplashPage": false,
        "showCurrentBenefitsWidget": true,
        "showClaimsTRSWidgets": true,
        "showWellOneWidget": false,
        "pensionFilesCorrespondenceTypeGUD": "",
        "hideCurrentBenefitCount": false,
        "showAIWidget": true,
        "showisStudentSpouse": true,
        "editisStudentSpouse": true,
        "showisStudentChild": false,
        "editisStudentChild": true,
        "showisStudentOther": true,
        "editisStudentOther": true,
        "isContactPreferencesEditable": true,
        "isPhoneEditable": true,
        "isPersonalEmailEditable": true,
        "enableMarketingConsent": true,
        "hideBenefitLearnMoreLinkFromProfile": true,
        "showMyBenefits": true,
        "showBenefitEnrolmentSummaryProfile": true,
        "useYTDForPaymentSourceInitialBalance": false,
        "hidePendingBenefitsPage": false,
        "showSaveQuotes": false,
        "showDependantsAndBeneficiaries": true,
        "showInsuredClaims": true,
        "showDocuments": true,
        "showPayments": true,
        "showLifeEvents": true,
        "showAlerts": false,
        "showUserName": true,
        "openRegisterDependentForm": false,
        "enableCustomLoginLinks": true,
        "hideAccountTabPasswordSection": false,
        "showAllForthComingPayments": false,
        "hideFailedPaymentTransactions": false,
        "showFailedPaymentRejectionReason": false,
        "showOnlineBenefitPayments":false,
        "hideProfileAccount": false,
        "showCitizenshipCountry": true,
        "showCountryOfBirth": true,
        "showNationalIDType": true,
        "showNationalID": true,
        "showDateOfHire": false,
        "showBusinessPhone": true,
        "showBusinessEmail": true,
        "showPersonalPhone": true,
        "showPersonalEmail": true,
        "showEmployeeLegalName": false,
        "showPassportID": false,
        "showTaxID": false,
        "showLastName2": false,
        "showEmploymentStatus": false,
        "showPayrollID": false,
        "showEmployeeMaritalStatus": true,
        "showCompensationBaseSalary": true,
        "showSystemID": false,
        "showOtherID": false,
        "showEmployeeNumberID": true,
        "showJobLevel": false,
        "showJobStatus": false,
        "showJobType": false,
        "showPayrollGroup": false,
        "showPayType": false,
        "showBonusAmount": false,
        "showBonusFrequency": false,
        "showPensionSalaryAmount": false,
        "showReferenceSalaryAmount": false,
        "showMiscCompensation1": false,
        "showMiscCompensation2": false,
        "showOperatingUnit": false,
        "showDivision": false,
        "showCompany": false,
        "showHolidayEntitlement": false,
        "showWeeklyHours": false,
        "showMaximumDeductionCapacity": false,
        "showSalaryBandLevel": false,
        "showGrossMonthSalary": false,
        "showPreferredName": false,
        "hideDateOfBirth": false,
        "hideGender": false,
        "enableEditQuote": true,
        "showProfileAddressLine1": true,
        "showProfileAddressLine2": true,
        "showProfileAddressLine3": false,
        "showProfileHomePostalCode": true,
        "showProfileStateProvince": true,
        "showContactPreferenceHomeCountry": true,
        "profileAddressLine1Editable": true,
        "profileAddressLine2Editable": true,
        "profileAddressLine3Editable": false,
        "profileHomePostalCodeEditable": true,
        "profileStateProvinceEditable": true,
        "allowDependantEdit": true,
        "allowOnlyDependantTrusteeEdit": false,
        "hideDependantEditInBeneficiary": false,
        "allowBeneficiaryAllocationEdit": true,
        "showBeneficiaryAddressState": true,
        "showStructuredAddresses": true,
        "hideBeneficiariesTab": false,
        "hideDependantsTab": false,
        "hideTodayDateInCurrentPlans": false,
        "showHomeEmailPreferred": true,
        "hideEmployeeDocumentsTab": false,
        "hideHistoricalBenefitStatementsTab": false,
        "hideAdminDocumentsTab": false,
        "showLoginWelcomeText": false,
        "hideExpiringBenefitTab": false,
        "hideEmployeeFirstName": false,
        "hideEmployeeLastName": false,
        "currencyFormatOverride": "",
        "currencySymbolPosition": "Left",
        "currencyFormat": "12,34,567.89",
        "currencySymbolWithSpace": false,
        "currencyFormatOverrideByResourceString": false,
        "claimAcknowledgementSlip": true,
        "customClaimAcknowledgementTemplateType": "1",
        "hideOverviewTab": false,
        "trsYearComparisonColors": "#c8ff00,#000000",
        "enableHighContrastMode": false,
        "presetTheme": "theme-red",
        "enableDarkMode": false,
        "clientPrimaryBrandColour": "#004852",
        "logoPath": "https://qa-nextgenolb-imp.tbs.aon.com/api/media/NextGenOLB/Images/logos/everyday-logo-sm.svg",
        "enableMFA": false,
        "enableMFAEmail": false,
        "enableMFAMobile": false,
        "enableMFAOktaVerify": false,
        "enableOverrideMFAData": false,
        "mfaUniqueIdentifier": "",
        "showAnnualPayPeriodDisplayToggle": false,
        "showAddEditDependents": true,
        "showBenefitLearnMore": true,
        "showAlertPopup": true,
        "showActiveEventWindow": true,
        "flowStateBar": true,
        "showEnrolmentSummary": true,
        "showImportantInfoUnderPlanDetails": true,
        "hideTotalRowsOnBenefitSelectionFlow": false,
        "displayManualAllocationPromptOnBenefitFlowCompletion": true,
        "showPendingEOIInformationAtTheTopOfTheCoverageActivity": true,
        "showIconAndBenefitGroupLabel": true,
        "showEEERTotalCostBreakDown": true,
        "showTaxCodeInputModelling": true,
        "showBusStopPopupDisplay": true,
        "spawnControlIcon": "aon-coins",
        "showActiveEventBroadcastBar": true,
        "showOutstandingInsuredClaims": true,
        "hideEmployerCostForAllBenefit": false,
        "hideInformationalBanner": false,
        "showEmployerCostInReviewActivity": true,
        "showOnlyPayrollGroupFromEmployee": true,
        "isAddressLine1Optional": false,
        "isAddressLine2Optional": false,
        "isCityOptional": false,
        "isStateOptional": false,
        "isZipCodeOptional": false,
        "enableSingleProductCheckout": false,
        "productForExternalData": "",
        "sableFormForExternalProduct": "",
        "defaultToCardBasedResultView": false,
        "enableGlobalProductNavigation": false,
        "removeIconWaveBackgroundImagePageHeader": false,
        "displayFAQsWithSideNavigationInsteadAtTheBottomOfThePage": true,
        "hideFAQsBreadcrumb": true,
        "roleToLanguageEnable": false,
        "defaultCostFrequency": 0,
        "selfRegistrationEnabled": true,
        "accountRegistrationFormID": "da6f8d12-3f5b-4f9b-af38-37e2fd24fc31",
        "disableRegistrationPrivacyandTerms": false,
        "disableMarketingConsentCollectionOnSelfRegistration": false,
        "disableMarketingConsentDuringLogin": false,
        "hideAlternateRegistrationEmail": true,
        "hideRegistrationConsentStep": false,
        "hideFSABalance": false,
        "showExpenseCause": false,
        "showSubmissionDate": true,
        "showStatusDate": true,
        "showPaymentMethod": true,
        "showClinic": true,
        "showPaymentStatus": true,
        "showPaymentDate": true,
        "claimReceiptCurrencyReadOnly": false,
        "claimIndividualBalanceDisplay": false,
        "allowEditRequestForInfoClaims": true,
        "loginByMitIDOnly": false,
        "showDisabled": false,
        "showMedicareEligible": true,
        "disableServiceNow": false,
        "showExternalLinkPopup": true,
        "showWalletSummaryWidget": true,
        "showInsuredClaimsWidget": true,
        "lifeEventCalendarRangeBefore": "3",
        "lifeEventCalendarRangeAfter": "2",
        "lifeEventCalendarRangeEnabled": true,
        "lifeEventCalendarBeforeNoRangeLimitEnabled": false,
        "lifeEventCalendarAfterNoRangeLimitEnabled": false,
        "isJITCSSUsed": true,
        "dependentNationalIDDisplay": false,
        "profileBeneficiariesInfoDisplay": false,
        "profileSecurityInfoDisplay": true,
        "requireDependantSSN": true,
        "sSNFormat": "123456789",
        "dependentLegalNameDisplay": true,
        "beneficiaryLegalNameDisplay": true,
        "showPolicyFilters": true,
        "profileDependantInfoDisplay": true,
        "logoImagePath": "test",
        "homePagePath": "test",
        "webChatIcon": "test",
        "currencySymbol": "test",
        "disableWebChat": false,
        "campaignPageComponentBackgroundDisplay": "flattened",
        "webChatTextColor": "test",
        "webChatBackgroundColor": "test",
        "requireDocumentAttachment": true,
        "hideNumberOfPaymentsInPaymentCompletePage": true,
        "enableAdhocEmployeeDocumentUpload": false,
        "outstandingClaimStateIcon": "fa-duotone fa-solid fa-file-invoice-dollar",
        "outstandingDocumentStateIcon": "fa-duotone fa-solid fa-book-open",
        "profileBankAccountInfoDisplay": false,
        "showBankName": false,
        "requiredBankName": false,
        "showBankCode": false,
        "requiredBankCode": false,
        "showBranchCode": false,
        "requiredBranchCode": false,
        "showAccountNumber": false,
        "requiredAccountNumber": false,
        "showBranchName": false,
        "requiredBranchName": false,
        "showBranchDigit": false,
        "requiredBranchDigit": false,
        "showAccountDigit": false,
        "requiredAccountDigit": false,
        "showRoutingNumber": false,
        "requiredRoutingNumber": false,
        "showAccountType": false,
        "requiredAccountType": false,
        "showBankDetailDisclaimer": false,
        "requiredAccountNumberValidation": false,
        "requiredRoutingNumberValidation": false,
        "isBankDetailsEditable": false,
        "showMyPolicies": true,
        "showMobileNavigationMenus": false
      },
    }

    component.instance.resourcestrings = {
      "Aon.Alert.Title": "",
      "Aon.Alert.Description": "",
      "Aon.AddDependents": "",
      "Aon.BenefitDetails.CoveredTitle": "",
      "Aon.BenefitMatrix.BenefitsTable.Title.Review": "",
      "Aon.BenefitMatrix.IntroText.OpenEnrolment.ToEnrol": "",
      "Aon.BenefitMatrix.IntroText.OpenEnrolment.YouHave": "",
      "Aon.BenefitMatrix.IntroText.OpenEnrolment.OneDayToEnrol": "",
      "Aon.BenefitMatrix.IntroText.OpenEnrolment.LastDayToEnrol": "",
      "Aon.BenefitMatrix.MustSubmitInfo": "",
      "Aon.Beneficiary.allocation": "",
      "Aon.BenefitMatrix.Enrol": "",
      "Aon.BenefitMatrix.ViewBenefit": "",
      "Aon.Breadcrumb.Previous": "",
      "Aon.Common.About": "",
      "Aon.Common.AddEditDependents": "",
      "Aon.Common.All": "",
      "Aon.Common.Back": "",
      "Aon.Common.BannerTitle.Caution": "",
      "Aon.Common.BannerTitle.Error": "",
      "Aon.Common.BannerTitle.Error.Plural": "",
      "Aon.Common.BannerTitle.Info": "",
      "Aon.Common.BannerTitle.MultiInstance.Info": "",
      "Aon.Common.BannerTitle.MultiInstance.message": "",
      "Aon.Profile.MultiPet": "",
      "Aon.Profile.SinglePet": "",
      "Aon.Common.BannerTitle.Info.Plural": "",
      "Aon.BannerAlert.Close": "",
      "Aon.Common.BannerTitle.Success": "",
      "Aon.Common.RedirectInfoTitle": "",
      "Aon.Common.RedirectInfoText": "",
      "Aon.Common.BaseSalary": "Base Salary",
      "Aon.Common.Brochure": "",
      "Aon.Common.Cancel": "",
      "Aon.Common.ChangePwdSuccessfully": "",
      "Aon.Common.Citizenship": "Citizenship",
      "Aon.Common.Confirm": "",
      "Aon.Common.ConfirmDelete": "",
      "Aon.Common.ConfirmDeleteQuote": "",
      "Aon.Common.Continue": "",
      "Aon.Common.CultureShortName": "",
      "Aon.Common.DateOfHire": "Date of Hire",
      "Aon.Common.Day": "",
      "Aon.TRS.Total": "",
      "Aon.Common.Delete": "",
      "Aon.Common.DOB": "Date of Birth",
      "Aon.Common.Download": "",
      "Aon.Common.Edit": "",
      "Aon.Common.Selected": "",
      "Aon.Common.EmailLabel": "",
      "Aon.Common.EmploymentStatus": "Employment Status",
      "Aon.Common.Error": "",
      "Aon.Common.ErrorBannerTitle": "",
      "Aon.Common.ErrorIntro": "",
      "Aon.Common.ErrorTitle": "",
      "Aon.Common.FaqsTitle": "",
      "Aon.Common.FlexiPointBalance": "",
      "Aon.Common.FlexiPointsDescription": "",
      "Aon.Common.FlexiPointsNotAvailable": "",
      "Aon.Common.Gender": "Gender",
      "Aon.Common.GetAQuote": "",
      "Aon.Common.GetAQuote.NextGenOLB": "",
      "Aon.Common.HelpsTitle": "",
      "Aon.Common.KeepWorking": "",
      "Aon.Common.LearnMore": "",
      "Aon.Common.Loading": "",
      "Aon.Common.MaritalStatus": "Marital Status",
      "Aon.Common.Month": "",
      "Aon.Common.Name": "Name",
      "Aon.Common.NationalID": "National ID",
      "Aon.Common.NoResultToDisplay": "",
      "Aon.Common.NotOnFile": "",
      "Aon.Common.OK": "",
      "Aon.Common.Per": "",
      "Aon.Common.PersonalEmail": "",
      "Aon.Common.PhoneNumber": "",
      "Aon.Common.PlaceOfBirth": "Place Of Birth",
      "Aon.Common.Print": "",
      "Aon.Common.PrivacyPolicy": "",
      "Aon.Common.ResendEmail": "",
      "Aon.Common.ResetPurchase": "",
      "Aon.Common.ResetPurchaseSuccess": "",
      "Aon.Common.ResetPurchaseWarningMsg": "",
      "Aon.Common.Save": "",
      "Aon.Common.Skip": "",
      "Aon.Common.Self": "",
      "Aon.Common.ShopNow": "",
      "Aon.Common.Submit": "",
      "Aon.Common.SubTotal": "",
      "Aon.Common.Success": "",
      "Aon.Common.SuccessMessage": "",
      "Aon.Common.TermsOfUse": "",
      "Aon.Common.TimeoutInfoPrefix": "",
      "Aon.Common.TimeoutInfoSuffix": "",
      "Aon.Common.TimeoutTitle": "",
      "Aon.Common.Today": "",
      "Aon.Common.WorkEmail": "",
      "Aon.Common.Year": "",
      "Aon.Common.Proceed": "",
      "Aon.Common.TryAgain": "",
      "Aon.Common.Yes": "Yes",
      "Aon.Common.No": "No",
      "Aon.Common.Required": "",
      "Aon.Common.FileSize.MB": "",
      "Aon.Common.TooManyRequests": "",
      "Aon.Common.Waive": "",
      "Aon.Common.Accept": "",
      "Aon.Common.PleaseCheck": "",
      "Aon.Common.InvalidData": "",
      "Aon.Common.Trs.Download": "",
      "Aon.Common.TryAgainLater": "",
      "Aon.Common.ServiceUnavailable": "",
      "Aon.Common.MisMatchUserError": "",
      "Aon.Common.OnlineSecurity": "",
      "Aon.Common.GoToHome": "",
      "Aon.Common.PopupBlockedTitle": "",
      "Aon.Common.PopupBlockedInfo": "",
      "Aon.Common.For": "",
      "Aon.Common.iUnderstand": "",
      "Aon.Common.NoClientCodeHeader": "",
      "Aon.Common.NoClientCodeInfo": "",
      "Aon.Common.PasswordExpiredMessage": "",
      "Aon.Common.NoAccountFunctionProvided": "",
      "Aon.Common.Document": "",
      "Aon.Common.Consent": "",
      "Aon.Common.NoAccessRightMsg": "",
      "Aon.Common.GlobalError": "",
      "Aon.Common.Alert": "",
      "Aon.Common.EffectiveDate": "",
      "Aon.Common.Me": "",
      "Aon.Common.Remove": "",
      "Aon.Common.Confirmation": "",
      "Aon.Common.ConfirmPromoteToProd": "",
      "Aon.PayFrequency.Monthly": "",
      "Aon.PayFrequency.Quarterly": "",
      "Aon.PayFrequency.SemiAnnual": "",
      "Aon.PayFrequency.Annual": "",
      "Aon.PayFrequency.OneTime": "",
      "Aon.PayFrequency.Daily": "",
      "Aon.PayFrequency.Weekly": "",
      "Aon.PayFrequency.BiWeekly": "",
      "Aon.PayFrequency.SemiMonthly": "",
      "Aon.PayFrequency.FourWeekly": "",
      "Aon.PayFrequency.PerPay": "",
      "Aon.Frequency.Day": "",
      "Aon.Frequency.Week": "",
      "Aon.Frequency.Month": "",
      "Aon.Frequency.Year": "",
      "Aon.Common.PleaseChoose": "",
      "Aon.Common.AddDependents": "",
      "Aon.Common.Done": "",
      "Aon.Common.AddEditDependentsDesc": "",
      "Aon.Error.DateNotBeFuture": "",
      "Aon.PayrollDeduction.Title": "",
      "Aon.PayrollDeduction.Description": "",
      "Aon.PayrollDeduction.ToolTipText": "",
      "Aon.DirectPay.Title": "",
      "Aon.DirectPay.Description": "",
      "Aon.DirectPay.ToolTipText": "",
      "Aon.DirectPay.Label": "",
      "Aon.Dependents.Header": "",
      "Aon.DeletePopup.Title": "",
      "Aon.DeletePopup.Description": "",
      "Aon.DeletePopup.DropDependantPolicies.Description": "",
      "Aon.EnrolmentSummary.EmployerDescription": "",
      "Aon.EventBroadcast.EnrolmentItems": "",
      "Aon.EventBroadcast.Strapline": "",
      "Aon.EventBroadcast.ViewItems": "",
      "Aon.Funds.AllocatedFunds": "",
      "System.Common.Cancel": "",
      "Aon.Common.Total": "",
      "Aon.Common.LastUpdated": "",
      "Aon.Common.Your": "",
      "Aon.Common.Select": "",
      "Aon.Common.DeSelect": "",
      "Aon.Common.Warning": "",
      "Aon.Login.PasswordVisibilityControl": "",
      "Aon.Common.NoQuotesReadyForCheckout": "",
      "Aon.Common.PageLoading": "",
      "Aon.Common.PageLoaded": "",
      "Aon.Common.PayrollID": "Payroll ID",
      "Aon.Arialabel.Info": "",
      "Aon.Common.MFALabel": "",
      "Aon.MFA.Email": "",
      "Aon.MFA.Phone": "",
      "Aon.MFA.ChooseOption": "",
      "Aon.MFA.UpdateSuccess": "",
      "Aon.MFA.CountryPhoneCode": "",
      "Aon.Common.YesDeselect": "",
      "Aon.Common.NoDeselect": "",
      "Aon.Benefit.AmountType.Day": "",
      "Aon.Benefit.AmountType.Days": "",
      "Aon.Benefit.AmountType.Hour": "",
      "Aon.Benefit.AmountType.Hours": "",
      "Aon.Error.ContactUs": "",
      "Aon.Common.VideoContentLoading": "",
      "Aon.Common.VideoContentLoaded": "",
      "Aon.Common.IsMedicareEligible": "Is Medicare Eligible",
      "Aon.Common.IsDisabled": "",
      "Aon.EventBroadcast.ModalHeader": "",
      "Aon.AdditionalEvents.Signpost.Widget.Heading.ToDo": "",
      "Aon.Common.SkipToMainContent": "",
      "Aon.Common.SystemID": "",
      "Aon.Common.OtherID": "",
      "Aon.Common.EmployeeNumberID": "Employee Number ID",
      "Aon.Common.JobLevel": "",
      "Aon.Common.JobStatus": "",
      "Aon.Common.JobType": "",
      "Aon.Common.PayrollGroup": "",
      "Aon.Common.PayType": "",
      "Aon.Common.BonusAmount": "",
      "Aon.Common.BonusFrequency": "",
      "Aon.Common.PensionSalaryAmount": "",
      "Aon.Common.ReferenceSalaryAmount": "",
      "Aon.Common.MisCompensation1": "",
      "Aon.Common.MisCompensation2": "",
      "Aon.Common.OperatingUnit": "",
      "Aon.Common.Division": "",
      "Aon.Common.Company": "",
      "Aon.Common.HolidayEntitlement": "",
      "Aon.Common.Days": "",
      "Aon.Common.Hours": "",
      "Aon.Common.WeeklyHours": "",
      "Aon.Common.DeductionCapacity": "",
      "Aon.Common.GrossMonthlySalary": "",
      "Aon.Common.SalaryBandLevel": "",
      "Aon.Modal.CloseButton.AriaLabel": "",
      "Aon.Common.Optional": "",
      "Aon.Common.PasswordExpirationWarningMessage": "",
      "Aon.Common.Preferred": "",
      "Aon.Help.JumpToSection": "",
      "Aon.Pattern.Fail.Message": "",
      "Aon.Common.Gender.Melded": "",
      "Aon.Common.NotAvailable": "",
      "Aon.Common.GetStarted": "",
      "Aon.Common.ContinueShopping": "",
      "Aon.Savedquote.Info.Title": "",
      "Aon.Savedquote.Info.Description": "",
      "Aon.Savedquote.Info.Yes": "",
      "Aon.Savedquote.Info.No": "",
      "Aon.SelfService.CTA.Delete.ConfirmationModal.Header.Label": "",
      "Aon.SelfService.CTA.Label": "",
      "Aon.SelfService.CTA.Modal.Edit.Header.Label": "",
      "Aon.TRSOverview.LastUpdated": "",
      "Aon.Common.NationalIDType": "National ID Type",
      "Aon.Common.Title": "",
      "Aon.Common.Next": "",
      "Aon.Common.Close": "",
      "Aon.Profile.AboutMe": "",
      "Aon.Profile.Account": "",
      "Aon.Profile.Address": "",
      "Aon.Profile.ChangeUserName": "",
      "Aon.Profile.ConfirmPersonalInfo": "",
      "Aon.Profile.ContactPreferences": "",
      "Aon.Profile.ContactPreferencesError": "",
      "Aon.Profile.InvalidEmail": "",
      "Aon.Profile.InvalidPhoneNumber": "",
      "Aon.Profile.PersonalEmailUpdateSuccessfully": "",
      "Aon.Profile.PersonalInformation": "Personal Information",
      "Aon.Profile.Phone": "",
      "Aon.Profile.RetrieveMyQuote": "",
      "Aon.Profile.SavedQuotes": "",
      "Aon.Profile.SavedQuotesIntro": "",
      "Aon.Profile.UpdatePhoneSuccessInfo": "",
      "Aon.Profile.Comms.SubscriptionStatus.Description": "",
      "Aon.Profile.Comms.Subscription.CheckboxLabel": "",
      "Aon.Profile.CommunicationPreferences": "",
      "Aon.Profile.Marketing.Selection": "",
      "Aon.Profile.SaveCommunicationPreferencesSuccess": "",
      "Aon.Profile.CommunicationPreferencesModalTitle": "",
      "Aon.Profile.WhoIsCovered": "",
      "Aon.Profile.Per": "",
      "Aon.Profile.SaveContactDetailsSuccess": "",
      "Aon.Profile.PersonalInfoTip": "",
      "Aon.Profile.BenefitsTitle": "",
      "Aon.Profile.BenefitsIntro": "",
      "Aon.Profile.DeductionsTitle": "",
      "Aon.Profile.DeductionsIntro": "",
      "Aon.Profile.DeductionsAppliedTitle": "",
      "Aon.Profile.DeductionsAppliedIntro": "",
      "Aon.Profile.DeductionsAppliedPDFLinkText": "",
      "Aon.Profile.CombineDeductionsIntro": "",
      "Aon.Profile.Coverage": "",
      "Aon.Profile.PerPayPeriod": "",
      "Aon.Profile.EffectiveDate": "",
      "Aon.Profile.DownloadPDFLinkText": "",
      "Aon.Profile.TotalDeductionLabel": "",
      "Aon.Profile.Brochure.Url.Metlife": "",
      "Aon.Profile.Brochure.Url.SafeCo": "",
      "Aon.Profile.CompleteMyQuote": "",
      "Aon.Profile.QuoteDetails": "",
      "Aon.Profile.CreatedLabelText": "",
      "Aon.Profile.Incomplete": "",
      "Aon.Profile.CarrierNumber.Metlife": "",
      "Aon.Profile.CarrierNumber.SafeCo": "",
      "Aon.Profile.CarrierNumber.Nationwide": "",
      "Aon.Profile.Brochure.Url.Nationwide": "",
      "Aon.Profile.SaveCommunicationPreferencesSuccessPreAboutMe": "",
      "Aon.Profile.SaveCommunicationPreferencesSuccessAfterAboutMe": "",
      "Aon.Profile.NoBenefitsToDisplay": "",
      "Aon.Profile.NoSavedQuotesToDisplay": "",
      "Aon.Profile.InProgressQuotes": "",
      "Aon.Profile.DeductionsAppliedPDFAddress": "",
      "Aon.Profile.InvalidUserName": "",
      "Aon.Profile.UpdateUserNameSuccess": "",
      "Aon.Profile.DeleteQuoteTitle": "",
      "Aon.Profile.Password.NeedMeetRequirements": "",
      "Aon.Profile.Password.CannotBeReused": "",
      "Aon.Profile.Password.ReusePolicy": "",
      "Aon.Profile.UserNameExists": "",
      "Aon.Profile.UserNotExists": "",
      "Aon.Profile.Benifits": "",
      "Aon.Profile.Beneficiaries": "",
      "Aon.Profile.Payment": "",
      "Aon.Profile.ActiveBenefits.MyBenefits": "",
      "Aon.Profile.ActiveBenefitsAsia.ActiveBenefits": "",
      "Aon.Profile.ActiveBenefitsAsia.SubActiveBenefits": "",
      "Aon.Profile.ActiveBenefitsAsia.EffectiveDate": "",
      "Aon.Profile.ActiveBenefitsAsia.FilterByProduct": "",
      "Aon.Profile.ActiveBenefitsAsia.DownloadSummary": "",
      "Aon.Profile.ActiveBenefitsAsia.Download": "",
      "Aon.Profile.ActiveBenefitsAsia.Print": "",
      "Aon.Profile.ActiveBenefitsAsia.NoResultToDisplay": "",
      "Aon.Profile.ActiveBenefitsAsia.ExpiresSoonLabel": "",
      "Aon.Profile.ActiveBenefitsAsia.ActivePolicyLabel": "",
      "Aon.Profile.ActiveBenefitsAsia.PendingPolicyLabel": "",
      "Aon.Profile.ActiveBenefitsAsia.CancelledPolicyLabel": "",
      "Aon.Profile.ActiveBenefitsAsia.PerYear": "",
      "Aon.Profile.ActiveBenefitsAsia.Coverage": "",
      "Aon.Profile.ActiveBenefitsAsia.PlanDetails": "",
      "Aon.Profile.ActiveBenefitsAsia.Term": "",
      "Aon.Profile.ActiveBenefitsAsia.PrimaryBeneficiaries": "",
      "Aon.Profile.ActiveBenefitsAsia.SecondaryBeneficiaries": "",
      "Aon.Profile.ActiveBenefitsAsia.PolicyNumber": "",
      "Aon.Profile.ActiveBenefitsAsia.Claims": "",
      "Aon.Profile.ActiveBenefitsAsia.EditPolicy": "",
      "Aon.Profile.ActiveBenefitsAsia.CancelPolicy": "",
      "Aon.Profile.ActiveBenefitsAsia.NeedHelp": "",
      "Aon.Profile.ActiveBenefitsAsia.AonHelpDesk": "",
      "Aon.Profile.ActiveBenefitsAsia.AonHelpDeskContactDetails": "",
      "Aon.Profile.ActiveBenefitsAsia.PhoneNumber": "",
      "Aon.Profile.ActiveBenefitsAsia.Email": "",
      "Aon.Profile.ActiveBenefitsAsia.EmailAddress": "",
      "Aon.Profile.DependentsAndBeneficiaries": "",
      "Aon.Profile.Documents": "",
      "Aon.Profile.InsuredClaims": "",
      "Aon.Profile.InvalidNationalId": "",
      "Aon.Profile.SaveNationalIDSuccess": "",
      "Aon.Profile.CallAnAgentPDFFileName": "",
      "Aon.Profile.AboutMeIntro ": "",
      "Aon.Profile.activeBenefits": "",
      "Aon.Profile.AddPersonalEmail": "",
      "Aon.Profile.AddressLine1": "",
      "Aon.Profile.AddressLine2": "",
      "Aon.Profile.AddressLine3": "",
      "Aon.Profile.BeneficiariesIntro": "",
      "Aon.Profile.BirthDate": "",
      "Aon.Profile.CancelAutoRenewalPolicy": "",
      "Aon.Profile.CancelAutoRenewalPolicySuccess": "",
      "Aon.Profile.CancelPolicy": "",
      "Aon.Profile.CancelPolicyHideRefundAmount": "",
      "Aon.Profile.CancelPolicyInCoolOffPeriodHideRefundAmount": "",
      "Aon.Profile.CancelPolicyInCoolOffPeriodShowRefundAmount": "",
      "Aon.Profile.CancelPolicyIntro": "",
      "Aon.Profile.CancelPolicyIntroCoolOffPeriod": "",
      "Aon.Profile.CancelPolicyNoClaimsMadeInfo": "",
      "Aon.Profile.CancelPolicyNoClaimsMadeWarning": "",
      "Aon.Profile.CancelPolicyNoFollowUpMsg": "",
      "Aon.Profile.CancelPolicyShowRefundAmount": "",
      "Aon.Profile.CancelPolicySuccess": "",
      "Aon.Profile.CancelProceedConfirm": "",
      "Aon.Profile.CancelRefundAmount": "",
      "Aon.Profile.ChangePassword": "",
      "Aon.Profile.Citizenship": "Citizenship",
      "Aon.Profile.CommunicationPreferencesIntro": "",
      "Aon.Profile.CountryOfBirth": "India",
      "Aon.Profile.dependants": "",
      "Aon.Profile.DependentsIntro": "",
      "Aon.Profile.Email": "",
      "Aon.Profile.Gender": "",
      "Aon.Profile.HomeCity": "",
      "Aon.Profile.HomeCountry": "",
      "Aon.Profile.HomePostalCode": "",
      "Aon.Profile.HomeStateProvince": "",
      "Aon.Profile.LapsingBenefits": "",
      "Aon.Profile.LapsingBenefitsIntro": "",
      "Aon.Profile.ManageProfileHeader": "",
      "Aon.Profile.MaritalStatus": "",
      "Aon.Profile.MarketingPreference.No": "",
      "Aon.Profile.MarketingPreference.Yes": "",
      "Aon.Profile.MarketingSelection": "",
      "Aon.Profile.MarketingSelectionConfirm": "",
      "Aon.Profile.MarketingSelectionConfirmMsg": "",
      "Aon.Profile.MarketingSendEmail": "",
      "Aon.Profile.Name": "",
      "Aon.Profile.NationalID": "",
      "Aon.Profile.NoBeneficiaryAllocation": "",
      "Aon.Profile.NoDependents": "",
      "Aon.Profile.Password": "",
      "Aon.Profile.PasswordIntro": "",
      "Aon.Profile.PersonalEmail": "",
      "Aon.Profile.PersonalInfo": "",
      "Aon.Profile.PersonalInfoIntro ": "",
      "Aon.Profile.PlaceOfBirth": "",
      "Aon.Profile.Region": "",
      "Aon.Profile.RelationshipType": "",
      "Aon.Profile.SelectCancelReason": "",
      "Aon.Profile.WorkEmail": "",
      "Aon.Profile.WorkPhone": "",
      "Aon.Profile.YourPayments": "",
      "Aon.Profile.DateOfBirth": "",
      "Aon.Profile.FirstName": "",
      "Aon.Profile.LastName": "",
      "Aon.Profile.RelationShipName": "",
      "Aon.Profile.DateOfMarriage": "",
      "Aon.Profile.TobaccoUser": "",
      "Aon.Profile.LegalName": "Legal Name",
      "Aon.Profile.Me": "",
      "Aon.Profile.Dependants": "",
      "Aon.Profile.Required": "",
      "Aon.Profile.MyPlans.DownloadSummary": "",
      "Aon.Profile.MyPlans.EffectiveDate": "",
      "Aon.Profile.MyPlans.FilterByProduct": "",
      "Aon.Profile.MyPlans.Title": "",
      "Aon.Profile.MyPlans.SubTitle": "",
      "Aon.Profile.MyPlans.ActivePlans": "",
      "Aon.Profile.MyPlans.Expiring": "",
      "Aon.Profile.MyPlans.ExpiresSoon": "",
      "Aon.Profile.MyPlans.ActivePolicy": "",
      "Aon.Profile.MyPlans.PendingPolicy": "",
      "Aon.Profile.MyPlans.CancelledPolicy": "",
      "Aon.Profile.MyPlans.Coverage": "",
      "Aon.Profile.MyPlans.PlanDetails": "",
      "Aon.Profile.MyPlans.Term": "",
      "Aon.Profile.MyPlans.PolicyNumber": "",
      "Aon.Profile.MyPlans.Claims": "",
      "Aon.Profile.MyPlans.EditPolicy": "",
      "Aon.Profile.MyPlans.CancelPolicy": "",
      "Aon.Profile.MyPlans.YourRenewal": "",
      "Aon.Profile.MyPlans.Expired": "",
      "Aon.Profile.MyPlans.RenewPolicy": "",
      "Aon.Profile.MyPlans.ExpiredBenefit": "",
      "Aon.Profile.MyPlans.PolicyDocuments": "",
      "Aon.Profile.MyPlans.YourRenewalHeader": "",
      "Aon.Profile.MyPlans.YourRenewalBody": "",
      "Aon.Profile.MyPlans.ExipredBenefitHeader": "",
      "Aon.Profile.MyPlans.ExpiredBenefitBody": "",
      "Aon.Profile.MyPlans.FailedPaymentHeader": "",
      "Aon.Profile.MyPlans.FailedPaymentBody": "",
      "Aon.Profile.MyPlans.ExpiredPolicy": "",
      "Aon.Profile.MyPlans.CancelPolicySuccess": "",
      "Aon.Profile.MyPlans.FailedPaymentAmount": "",
      "Aon.Profile.MyPlans.MakePayment": "",
      "Aon.Profile.MyPlans.ChangeMadeOn": "",
      "Aon.Profile.MyPlans.PolicyCancelledOn": "",
      "Aon.Profile.MyPlans.EmployeePolicyNumber": "",
      "Aon.Profile.MyPlans.CancelAutoRenewalPolicy": "",
      "Aon.Profile.MyPlans.CancelPolicyHideRefundAmount": "",
      "Aon.Profile.MyPlans.CancelPolicyShowRefundAmount": "",
      "Aon.Profile.MyPlans.CancelPolicyInCoolOffPeriodHideRefundAmount": "",
      "Aon.Profile.MyPlans.CancelPolicyInCoolOffPeriodShowRefundAmount": "",
      "Aon.Profile.MyPlans.CancelPolicyNoFollowUpMsg": "",
      "Aon.Profile.MyPlans.CancelPolicyNoClaimsMadeWarning": "",
      "Aon.Profile.MyPlans.CancelAutoRenewalPolicySuccess": "",
      "Aon.Profile.MyPlans.CancelPolicyNoClaimsMadeInfo": "",
      "Aon.Profile.MyPlans.CancelPolicyFailed": "",
      "Aon.Profile.MyPlans.UpcomingPolicy": "",
      "Aon.Profile.DependantsIntro": "",
      "Aon.Profile.DependantsPageHeader": "",
      "Aon.Profile.MyPlans.ApplicationReferenceNumber": "",
      "Aon.Profile.PreparedFor": "",
      "Aon.Profile.YourDependant": "",
      "Aon.Profile.YourDependants": "",
      "Aon.Profile.PendingBenefits": "",
      "Aon.Profile.LastName2": "",
      "Aon.Profile.Payroll.PendingPlans": "",
      "Aon.Profile.Payroll.CurrentPlans": "",
      "Aon.Profile.Payroll.SubTitle": "",
      "Aon.Profile.Payroll.Title": "",
      "Aon.Profile.ActiveBenefit": "",
      "Aon.Profile.PendingBenefit": "",
      "Aon.Profile.Benefit.UpdateBenefit": "",
      "Aon.Profile.LifeEvents": "",
      "Aon.Profile.HomeMobile": "",
      "Aon.Profile.Benefits": "",
      "Aon.Profile.Documents.Download.Label": "",
      "Aon.Profile.Documents.Edit.Label": "",
      "Aon.Profile.DateOfDeath": "",
      "Aon.Profile.DateOfDivorce": "",
      "Aon.Profile.Marital.Status": "",
      "Aon.Profile.HomeDistrict": "",
      "Aon.Profile.HomeSubDistrict": "",
      "Aon.Profile.AlternateCountry": "",
      "Aon.Profile.AlternateStateProvince": "",
      "Aon.Profile.AlternatePostalCode": "",
      "Aon.Profile.AlternateDistrict": "",
      "Aon.Profile.AlternateSubDistrict": "",
      "Aon.Profile.AlternateAddressLine1": "",
      "Aon.Profile.AlternateAddressLine2": "",
      "Aon.Profile.AlternateAddressLine3": "",
      "Aon.Profile.UseAlternateAddress": "",
      "Aon.Profile.UpdatePersonalInfoSuccess": "",
      "Aon.Profile.Title": "",
      "Aon.Profile.LTCRiderSelected": "",
      "Aon.Profile.ChildTermRider": "",
      "Aon.Profile.CoverageAmount": "",
      "Aon.Profile.Document.Url.Life": "",
      "Aon.Profile.Alert.NoEmailProvided": "",
      "Aon.Profile.Alert.RemovingPreferredEmail": "",
      "Aon.Profile.PrivacySettings": "",
      "Aon.Profile.Updated": "",
      "Aon.Profile.ForYou": "",
      "Aon.Profile.CarrierName": "",
      "Aon.Profile.YourCoverage": "",
      "Aon.Profile.Current": "",
      "Aon.Profile.Increase": "",
      "Aon.Profile.TotalCoverage": "",
      "Aon.Profile.PolicyNumber": "",
      "Aon.Profile.TotalCost": "",
      "Aon.Profile.SpouseCoverage": "",
      "Aon.Profile.CTRTotal": "",
      "Aon.Profile.LifeEvent.Button": "",
      "Aon.Profile.QuoteCreated": "",
      "Aon.Profile.Cost": "",
      "Aon.Profile.PhoneCountryRegion": "",
      "Aon.Profile.EmptyPhoneCountryRegion": "",
      "Aon.Profile.NationalIDType": "",
      "Aon.Profile.EffectiveDate.ToolTip": "",
      "Aon.Profile.PolicyEndDate": "",
      "Aon.Profile.TotalCoverage.Header": "",
      "Aon.Profile.AlternateCity": "",
      "Aon.Profile.CompensationBaseSalary": "",
      "Aon.Profile.PersonalPhone": "",
      "Aon.Profile.PreferredName": "",
      "Aon.Account.ChangePasswordIntro": "",
      "Aon.Account.Email": "",
      "Aon.Login.UserName": "",
      "Aon.QuoteReview.YearsOld": "",
      "Aon.Navigation.Benefits": "",
      "Aon.Beneficiary.Allocation.Wizard.Primary": "",
      "Aon.Beneficiary.Allocation.Wizard.Contingent": "",
      "Aon.Beneficiary.Allocation": "",
      "Aon.Beneficiary.Irrevocable": "",
      "Aon.Beneficiary.Revocable": "",
      "Aon.Validation.Invalid.ErrorMessage": "",
      "Aon.SR.Invalid.ErrorMessage": "",
      "Aon.Beneficiary.Delete.Successful": "",
      "Aon.Beneficiary.Delete.Failed": "",
      "Aon.PersonalEmail.Required.ErrorMessage": "",
      "Aon.EmailSelect.Intro": "",
      "Aon.Validation.Required.ErrorMessage": "",
      "Aon.MFA.UpdateAtleastOneChannel.ErrorMsg": "",
      "Aon.Preferences.HideSensitiveData.Heading": "",
      "Aon.Preferences.HideSensitiveData.Introduction": "",
      "Aon.Preferences.HideSensitiveData.Control.Label": "",
      "Aon.DocumentUpload.DocumentType": "",
      "Aon.DocumentUpload.Description": "",
      "Aon.DocumentUpload.Year": "",
      "Aon.DocumentUpload.DocumentTile": "",
      "Aon.DocumentUpload.DateUploaded": "",
      "Aon.DocumentUpload.FileSize": "",
      "Aon.DocumentUpload.AssociatedBenefits": "",
      "Aon.DocumentUpload.NoDataAvailable": "",
      "Aon.OLB.SearchLink": "",
      "Aon.DocumentUpload.DocumentSize": "",
      "Aon.DocumentUpload.Others": "",
      "Aon.DocumentUpload.Download": "",
      "Aon.Beneficiary.PrimaryBeneficiary": "",
      "Aon.Beneficiary.ContingentBeneficiary": "",
      "Aon.Beneficiary.DisclaimerPrefix": "",
      "Aon.Beneficiary.DisclaimerSuffix": "",
      "Aon.Beneficiary.Provider": "",
      "Aon.Beneficiary.ProviderLink": "",
      "Aon.FutureAllocatedBeneficiaries.Warning.Title": "",
      "Aon.FutureAllocatedBeneficiaries.Warning.Message": "",
      "Aon.Beneficiary.NominatedTrustee": "",
      "Aon.UnderWriting.Complete": "",
      "Aon.Documents.Title": "",
      "Aon.Documents.Desc": "",
      "Aon.Documents.Desc2": "",
      "Aon.UploadDocument.NoDocuments": "",
      "Aon.UploadDocument.UploadDocumentsText": "",
      "Aon.DocumentUpload.Uploads": "",
      "Aon.Documents.Complete": "",
      "Aon.Documents.Incomplete": "",
      "Aon.BenefitStatements.Tab.Title": "",
      "Aon.Results.Count.Singular": "",
      "Aon.Results.Count.Plural": "",
      "Aon.BenefitReview.CostFrequency": "",
      "Aon.BenefitReview.permonth": "",
      "Aon.BenefitReview.peryear": "",
      "Aon.Payment.Alert": "",
      "Aon.Payment.PaymentPage": "",
      "Aon.Tax.EESalesTax": "",
      "Aon.Tax.NtlTaxBen": "",
      "Aon.Tax.ERSalesTax": "",
      "Aon.Tax.ProvTaxBen": "",
      "Aon.Tax.LifeImputedInc": "",
      "Aon.Tax.DPImputedInc": "",
      "Aon.Tax.StateImputedInc": "",
      "Aon.Tax.SalesTax": "",
      "Aon.Tax.POSDisc": "",
      "Aon.Payment.Active": "",
      "Aon.Payment.ActiveDescription": "",
      "Aon.Payment.Inactive": "",
      "Aon.Payment.InactiveDescription": "",
      "Aon.Payment.SwitchPayment": "",
      "Aon.Payment.YourPaymentMethods": "",
      "Aon.Payment.ConfirmDeleteText": "",
      "Aon.Payment.ConfirmSwitchText": "",
      "Aon.Payment.Modal.Confirm": "",
      "Aon.Payment.ManagePaymentTitle": "",
      "Aon.Payment.ManagePaymentDescription": "",
      "Aon.Payment.SummaryOfSwitchProducts": "",
      "Aon.Payment.SwitchProductsIAgree": "",
      "Aon.PaymentDetails.Modal.DeleteSuccess": "",
      "Aon.PaymentDetails.Modal.DeleteFailed": "",
      "Aon.PaymentDetails.SwitchPaymentsSuccess": "",
      "Aon.Payment.ConfirmSwitch": "",
      "Aon.Payment.SwitchDescription": "",
      "Aon.Payment.SelectExistingDescription": "",
      "Aon.Payment.Modal.ConfirmText": "",
      "Aon.Payment.SwitchFrom": "",
      "Aon.Payment.Billingaddress": "",
      "Aon.Payment.CardEndingIn": "",
      "Aon.TransactionHistory.FailedPaymentsHeader": "",
      "Aon.TransactionHistory.FailedPaymentsTitle": "",
      "Aon.TransactionHistory.FailedPaymentsIntro": "",
      "Aon.TransactionHistory.TransactionDate": "",
      "Aon.TransactionHistory.Product": "",
      "Aon.TransactionHistory.Ref": "",
      "Aon.TransactionHistory.PaymentAmount": "",
      "Aon.TransactionHistory.PaymentType": "",
      "Aon.TransactionHistory.PaymentFrequency": "",
      "Aon.TransactionHistory.Actions": "",
      "Aon.TransactionHistory.CompletedPaymentsHeader": "",
      "Aon.TransactionHistory.CompletedPaymentsTitle": "",
      "Aon.TransactionHistory.CompletedPaymentsIntro": "",
      "Aon.TransactionHistory.NoCompletedPaymentRecordsMsg": "",
      "Aon.TransactionHistory.NoPaymentRecordsMsg": "",
      "Aon.TransactionHistory.PendingPaymentsHeader": "",
      "Aon.TransactionHistory.PendingPaymentsTitle": "",
      "Aon.TransactionHistory.PendingPaymentsIntro": "",
      "Aon.TransactionHistory.RefundedPaymentsHeader": "",
      "Aon.TransactionHistory.RefundedPaymentsTitle": "",
      "Aon.TransactionHistory.RefundedPaymentsIntro": "",
      "Aon.TransactionHistory.CancelledDate": "",
      "Aon.TransactionHistory.RefundAmount": "",
      "Aon.TransactionHistory.NextPaymentDate": "",
      "Aon.TransactionHistory.NextPayments": "",
      "Aon.TransactionHistory.PaymentHeader": "",
      "Aon.TransactionHistory.PaymentIntro": "",
      "Aon.TransactionHistory.ActionButtonTooltip": "",
      "Aon.TransactionHistory.PaymentDetailsHeader": "",
      "Aon.TransactionHistory.PaymentDetailsTitle": "",
      "Aon.TransactionHistory.PaymentDetailsIntro": "",
      "Aon.Payment.AccountEndingIn": "",
      "Aon.TransactionHistory.RejectionReason": "",
      "Aon.Payment.UpdateCard": "",
      "Aon.QuoteReview.YourInformation": "",
      "Aon.QuoteReview.Name": "",
      "Aon.QuoteReview.ZipCode": "",
      "Aon.QuoteReview.Email": "",
      "Aon.QuoteReview.PetType": "",
      "Aon.QuoteReview.MyPetProtection": "",
      "Aon.QuoteReview.MyPetProtectionWithWellness": "",
      "Aon.QuoteReview.TotalPayment": "",
      "Aon.QuoteReview.PayrollDeductionAmount": "",
      "Aon.QuoteReview.PolicyNumber": "",
      "Aon.QuoteReview.CoverageStartDate": "",
      "Aon.Coverage.CurrentCoverage": "",
      "Aon.Coverage.AdditionalCover": "",
      "Aon.Payment.PayrollDeduction": "",
      "Aon.Purchase.TransactionFailMessage": "",
      "Aon.BenefitReview.PromoCodeAppliedSuccessMsg": "",
      "Aon.MFA.MFAEmail": "",
      "Aon.MFA.TextMessage": "",
      "Aon.MFA.SelectVerificationMethod": "",
      "Aon.MFA.WorkEmailCannotEdit": "",
      "Aon.MFA.SentACodeTo": "",
      "Aon.MFA.BrowserMessage": "",
      "Aon.MFA.EnterCode": "",
      "Aon.MFA.EmptyPhone": "",
      "Aon.MFA.Verification.SystemErrorMessage": "",
      "Aon.MFA.SelectOption": "",
      "Aon.MFA.SystemErrorMessage": "",
      "Aon.MFA.SendCode": "",
      "Aon.MFA.Verify": "",
      "Aon.MFA.ResendCode.Info": "",
      "Aon.MFA.ResendCode": "",
      "Aon.MFA.CodeValidPeriodInfo": "",
      "Aon.MFA.Profile.MFAInstruction": "",
      "Aon.MFA.EmptyCountryCode": "",
      "Aon.MFA.EmptyOTP": "",
      "Aon.BenefitStatements.Heading": "",
      "Aon.BenefitStatements.Introduction": "",
      "Aon.HistoricalStatements.InfoBanner.Heading": "",
      "Aon.HistoricalStatements.InfoBanner.Paragraph": "",
      "Aon.BenefitStatements.DropDown.Label": "",
      "Aon.BenefitStatements.Introduction.NoRecords": "",
      "Aon.Payment.SwitchPaymentDescription": "",
      "Aon.Payment.MustSelectBenefit": "",
      "Aon.Payment.Policy": "",
      "Aon.Payment.Ending": "",
      "Aon.Payment.DueAmount": "",
      "Aon.EnrolmentSummary.IconControl.Tooltip": "",
      "Aon.BenefitMatrix.ViewMore.Desc": "",
      "Aon.Account.ChangePassword": "",
      "Aon.Account.CurrentPassword": "",
      "Aon.Account.NeedMeetRequirements": "",
      "Aon.Account.CannotBeReused": "",
      "Aon.Account.ReusePolicy": "",
      "Aon.Account.ContainsUserName": "",
      "System.Common.Save": "",
      "Aon.Account.ForgotPassword": "",
      "Aon.Account.PasswordBlockedKeyword": "",
      "Aon.Password.RepetitiveChar": "",
      "Aon.Password.SequentialChar": "",
      "Aon.Account.SampleEmail": "",
      "Aon.Account.EmailSentMsg": "",
      "Aon.Account.ContinueLogin": "",
      "Aon.Account.HaveAccount": "",
      "Aon.Account.ResetPassword": "",
      "Aon.Account.InputRecoveryEmail": "",
      "Aon.Account.WorkEmail": "",
      "Aon.Account.PasswordRequirements": "",
      "Aon.Password.TenChars": "",
      "Aon.Password.OneUpperCase": "",
      "Aon.Password.OneNumber": "",
      "Aon.Password.OneSpecialChar": "",
      "Aon.Account.PasswordRepeatMatch": "",
      "Aon.Account.NewPassword": "",
      "Aon.Account.ConfirmNewPassword": "",
      "Aon.Account.ResetPasswordSuccess": "",
      "Aon.Account.ReEnterNewPassword": "",
      "Aon.Password.OneLowerCase": "",
      "Aon.Account.PasswordShouldnotContainUsername": "",
      "Aon.Password.PasswordLength": "",
      "Aon.Dependent.EditDependent": "",
      "Aon.Dependent.AddDependent": "",
      "Aon.Dependent.DependentHasUniqueAddress": "",
      "Aon.Dependant.SaveDependantSuccess": "",
      "Aon.Participant.NoParticipantSelected": "",
      "Aon.Participant.YourRegisteredParticipants": "",
      "Aon.Dependent.ResetForm": "",
      "Aon.Dependent.ResetForm.AlertInfo": "",
      "Aon.Login.PasswordIsRequired": "",
      "Aon.Account.NeedHelp": "",
      "Aon.Login.LoginText": "",
      "Aon.Login.Password": "",
      "Aon.BenefitDetails.Title": "",
      "Aon.BenefitDetails.Description": "",
      "Aon.BenefitDetails.CardTitle": "",
      "Aon.BenefitDetails.PlanTitle": "",
      "Aon.BenefitDetails.PlanDetails": "",
      "Aon.BenefitDetails.Term": "",
      "Aon.BenefitDetails.Policy Number": "",
      "Aon.BenefitDetails.EmployerCost": "",
      "Aon.BenefitDetails.TotalCost": "",
      "Aon.BenefitDetails.CoverageDetails": "",
      "Aon.BenefitDetails.PendingCoverage": "",
      "Aon.BenefitDetails.CustomerSupport": "",
      "Aon.Benefit.EmployeeCost": "",
      "Aon.Benefit.EmployerCost": "",
      "Benefit.ExpansionPanelTable.EOI.YourCost": "",
      "Benefit.ExpansionPanelTable.EOI.EmployerCost": "",
      "Benefit.ExpansionPanelTable.EOI.TotalCost": "",
      "Benefit.ExpansionPanelTable.EOI.ActiveBenefitsPendingInformation": "",
      "Aon.Benefit.TotalCost": "",
      "Aon.Benefits.InterimCoverage": "",
      "Aon.Benefits.RequestedCoverage": "",
      "Benefit.ExpansionPanelTable.EOI.CustomerService": "",
      "Benefit.ExpansionPanelTable.EOI.CustomerService.Phone": "",
      "Benefit.ExpansionPanelTable.EOI.CustomerService.Hours": "",
      "Benefit.ExpansionPanelTable.EOI.CustomerService.Claims": "",
      "Benefit.ExpansionPanelTable.EOI.CustomerService.Saturday": "",
      "Benefit.ExpansionPanelTable.EOI.CustomerService.Sunday": "",
      "Benefit.ExpansionPanelTable.EOI.CustomerService.MondayToFriday": "",
      "Aon.BenefitMatrix.Update": "",
      "Aon.Tag.Pending": "",
      "Aon.Tag.NewBenefit": "",
      "Aon.Tag.Removed": "",
      "Aon.Tag.Updated": "",
      "Aon.Tooltip.PendingEOI": "",
      "Aon.BenefitMatrix.BuildAnother": "",
      "Aon.BenefitMatrix.Deselect": "",
      "Aon.ActiveBenefits.EditPolicyLabel": "",
      "Aon.BenefitCard.NoPoliciesToDisplayHeading": "",
      "Aon.BenefitCard.NoPoliciesToDisplay": "",
      "Aon.SSO.BenefitTag": "",
      "Aon.Benefit.Message.Delete": "",
      "Aon.Benefit.Message.New": "",
      "Aon.Benefit.Message.CostChange": "",
      "Aon.Benefit.Message.PlanChange": "",
      "Aon.Benefit.Message.DependantChange": "",
      "Aon.Benefit.Message.Header": "",
      "Aon.Benefit.FundingRelease": "",
      "Aon.Benefit.FundingForfeit": "",
      "Aon.BenefitDetails.OutstandingCost": "",
      "Aon.BenefitDetails.YourCost": "",
      "Aon.Tag.Credit": "",
      "Aon.PaymentSource.YourCost": "",
      "Aon.Benefit.EmployeeTaxes": "",
      "Aon.Benefit.EmployerTaxes": "",
      "Aon.ERTaxSummary.Popover.Title": "",
      "Aon.FundedTaxSummary.Popover.Title": "",
      "Aon.EETaxSummary.Popover.Title": "",
      "Aon.BenefitDetails.TaxDetails": "",
      "Aon.BenefitDetails.BenefitCost": "",
      "Aon.BenefitDetails.Funding": "",
      "Aon.BenefitDetails.FundingTaxes": "",
      "Aon.PaymentSource.YourCost.Adjusted": "",
      "Aon.Benefit.YourCost.Adjusted": "",
      "Aon.Benefit.EmployerCost.Adjusted": "",
      "Aon.Benefit.EmployeeTaxes.Adjusted": "",
      "Aon.Benefit.EmployerTaxes.Adjusted": "",
      "Benefit.NoInteractionPermitted.Message": "",
      "Aon.Benefit.Message.ReservedAmount": "",
      "Aon.Dependants.FutureExpire": "",
      "Aon.BenefitDetails.GoBack": "",
      "Aon.Dependent.FirstName": "",
      "Aon.Dependent.LastName": "",
      "Aon.Dependent.MiddleName": "",
      "Aon.Dependent.IsSmoker": "",
      "Aon.Dependent.IsFullTimeStudent": "",
      "Aon.Dependent.LastName2": "",
      "Aon.Dependent.LegalName": "",
      "Aon.Dependent.DeleteParticipant": "",
      "Aon.Dependent.RemoveParticipant": "",
      "Aon.Dependent.Cannot.DeleteParticipant": "",
      "Aon.Dependent.Confirm.DeleteParticipant": "",
      "Aon.Dependent.ToDeleteParticipant.ContactCentre": "",
      "Aon.Dependent.Cannot.DeleteParticipant.Information": "",
      "Aon.Dependent.Confirm.DeleteParticipant.System": "",
      "Aon.Dependent.Confirm.DeleteParticipant.Information": "",
      "Aon.Dependant.MaxInstanceError": "",
      "Aon.Error.InvalidDate": "",
      "Aon.MastheadInbox.close": "",
      "Aon.Dependent.isTaxDependent": "",
      "Aon.Dependent.IsDisabled": "",
      "Aon.Dependent.IsEmployed": "",
      "Aon.Dependent.IsMedicareEligible": "",
      "Aon.Dependent.HomeEmailPreferred": "",
      "Aon.Dependent.HomeEmailPreferredError": "",
      "Aon.Dependent.MotherName": "",
      "Aon.Dependent.MiscDate1": "",
      "Aon.Dependent.MiscDate2": "",
      "Aon.Dependent.MiscDate3": "",
      "Aon.Dependent.MiscText1": "",
      "Aon.Dependent.MiscText2": "",
      "Aon.Dependent.MiscText3": "",
      "Aon.Dependent.MiscText4": "",
      "Aon.Dependent.MiscText5": "",
      "Aon.Dependent.CPF": "",
      "Aon.Dependent.ConsentRequired": "",
      "Aon.Participant.ConsentPolicy": "",
      "Aon.Dependent.DeleteParticipant.BeneficiaryAllocations.Information": "",
      "Aon.Dependent.DeleteParticipant.BeneficiaryAllocations.Description": "",
      "Aon.Dependent.Cannot.Delete.BeneficiaryAllocations": "",
      "Aon.Dependent.Confirm.DeleteParticipant.InBenefits": "",
      "Aon.BeneficiaryIrrevocable.BannerTitle": "",
      "Aon.BeneficiaryIrrevocable.BannerMessage": "",
      "Aon.LockedParticipant.BannerTitle": "",
      "Aon.LockedParticipant.BannerMessage": "",
      "Aon.Beneficiary.Trustee.FirstName": "",
      "Aon.Beneficiary.Trustee.LastName": "",
      "Aon.Beneficiary.Trustee.Relationship": "",
      "Aon.Dependent.Add.TrusteeDetails.Header": "",
      "Aon.EventReview.BenefitsWithinEvent.Heading": "",
      "Aon.EventReview.BenefitsWithinEvent.Description": "",
      "Aon.EventReview.BenefitsOutsideTheEvent.Heading": "",
      "Aon.EventReview.BenefitsOutsideTheEvent.Description": "",
      "Aon.BenefitReview.TotalPayrollDeductions": "",
      "Aon.Tooltip.CreditInfo": "",
      "Aon.EventReview.Description.TaxNote": "",
      "Aon.PaymentSource.CostAllocation": "",
      "Aon.BenefitCost.Adjustments": "",
      "Aon.BenefitDetails.TaxInformation": "",
      "Aon.InterimCoverage.Tooltip": "",
      "Aon.RequestedCoverage.Tooltip": "",
      "Aon.InterimCoverage.Cost": "",
      "Aon.RequestedCoverage.Cost": "",
      "Aon.BenefitMatrix.PageTitle.Review": "",
      "Aon.BenefitMatrix.PageSubTitle.Review": "",
      "Aon.BenefitMatrix.IntroText.Review": "",
      "Aon.BenefitMatrix.Confirm": "",
      "Aon.BenefitMatrix.Back": "",
      "Aon.Benefit.ValidationTitle": "",
      "Aon.Benefit.ValidationError": "",
      "Aon.Benefit.ValidationWarning": "",
      "Aon.BenefitMatrix.Continue": "",
      "Aon.EnrolmentSummary.EmployerCost": "",
      "Aon.EnrolmentSummary.BenefitSpend": "",
      "Aon.EnrolmentSummary.EmployeeDescription": "",
      "Aon.EnrolmentSummary.PageTitle.Enrolment": "",
      "Aon.EnrolmentSummary.GlobalBenefits.BenefitSpend": "",
      "Aon.EnrolmentSummary.GlobalBenefits.EmployerCost": "",
      "Aon.EnrolmentSummary.GlobalEmployeeDescription": "",
      "Aon.EnrolmentSummary.GlobalEmployerDescription": "",
      "Aon.EventReview.GlobalBenefits.Heading": "",
      "Aon.EventReview.GlobalBenefits.Description": "",
      "Aon.EnrolmentSummary.TaxCode": "",
      "Aon.EnrolmentSummary.TaxCode.ToolTip": "",
      "Aon.EnrolmentSummary.TaxCode.Action.Calculate": "",
      "Aon.EnrolmentSummary.TaxCode.Heading": "",
      "Aon.EnrolmentSummary.TaxCode.Description": "",
      "Aon.EnrolmentSummary.TaxCode.Error.IsRequired": "",
      "Aon.EnrolmentSummary.TaxCode.Error.isPatternInvalid": "",
      "Aon.Payment.Source.AllocatedSpend": "",
      "Aon.Payment.Source.RemainingBalance": "",
      "Aon.EnrolmentSummary.TaxModeler.RelatedLink": "",
      "Aon.EnrolmentSummary.TaxCode.PlaceHolder": "",
      "Aon.BenefitMatrix.IntroText.Review.NonFlow": "",
      "Aon.Payment.Source.ReleaseBalance": "",
      "Aon.Summary.TaxNote": ""
  }
    component.instance.fromAIChat = true;
    component.instance.isPageStyle = PageStyleMode.DepInfo;
    component.instance.fromAIChat = true;
    component.instance.curEmployee = {
      "lastName2": "",
      "lookupGender_RecordID": 2,
      "gender": "vdsc",
      "homeAddress1": null,
      "homeAddress2": null,
      "homeAddress3": null,
      "homeAddress4": null,
      "homeAddress5": null,
      "homeAddress6": null,
      "homeBuildingNumber": null,
      "homeCity": null,
      "homeCountry": null,
      "homePostalCode": null,
      "homePhone": null,
      "workPhone": null,
      "workFax": null,
      "alternateAddress1": null,
      "alternateAddress2": null,
      "alternateAddress3": null,
      "alternateAddress4": null,
      "alternateAddress5": null,
      "alternateAddress6": null,
      "alternateBuildingNumber": null,
      "alternateCity": null,
      "alternateCountry": null,
      "alternatePostalCode": null,
      "alternatePhone": null,
      "alternateEmail": null,
      "jobStatus": null,
      "weeklyHours": null,
      "employmentStatus": null,
      "payType": "Pay Type",
      "payRollGroup": null,
      "salaryBaseAmount": 100000,
      "salaryBaseFrequency": "4",
      "salaryBaseCurrency_RecordID": "23794ed1-52f4-411c-8a3c-6519341548ee",
      "salaryBaseCurrencyCode": "INR",
      "bonusAmount": 1000,
      "bonusFrequency": null,
      "holidayEntitlementDays": null,
      "holidayEntitlementHours": null,
      "jobLocation_RecordID": null,
      "lookupMaritalStatus_RecordID": 1,
      "maritalStatus": "Single",
      "jobLevel": null,
      "department": null,
      "organizationalTitle": "",
      "costCenter": null,
      "bankName": null,
      "bankAccountNumber": null,
      "pensionSalaryAmount": null,
      "pensionSalaryCurrency_RecordID": null,
      "referenceSalaryAmount": null,
      "referenceSalaryCurrency_RecordID": null,
      "miscCompensation1": null,
      "miscCompensation1Currency_RecordID": null,
      "miscCompensation2": null,
      "miscCompensation2Currency_RecordID": null,
      "miscCompensation3": null,
      "miscCompensation3Currency_RecordID": null,
      "miscCompensation4": null,
      "miscCompensation4Currency_RecordID": null,
      "miscCompensation5": null,
      "miscCompensation5Currency_RecordID": null,
      "lifeStage": null,
      "payRollFrequency": null,
      "flexFund2": null,
      "preferredName": "",
      "preferredCulture": "en-US",
      "isMedicareEligible": false,
      "deductionCapacity": null,
      "isSmoker": false,
      "isDisabled": false,
      "isVeteran": false,
      "alternateStateProvince": null,
      "homeStateProvince": null,
      "canLogin": true,
      "alternateCountry_RecordID": null,
      "homeCountry_RecordID": null,
      "regionalAffiliation_RecordID": null,
      "regionalAffliationName": null,
      "regionalAffliationCode": null,
      "inactive": false,
      "ghost": false,
      "title": null,
      "citizenshipCountry": "India",
      "isFlexEligible": false,
      "division": null,
      "legalName": "",
      "passportID": "",
      "taxID": "",
      "jobType": null,
      "operatingUnit": null,
      "company": null,
      "passwordResetViaPaper": false,
      "pensionMembershipNumber": "",
      "timeWarpDate": "2025-09-18T00:00:00Z",
      "employeeType": "Heath Lambeth Group",
      "employeeBankAccounts": [],
      "calcFieldResults": [
          {
              "name": "button label",
              "calcResult": "hello \"quoted\" and hello 'quoted'"
          }
      ],
      "payrollFrequency_RecordID": 4,
      "contributionGroup": 0,
      "childTaxCreditAllocation": 0,
      "disabilityPercent": 0,
      "lookupNationalIDType_RecordID": "504be25e-fd26-4370-94f0-483bf1b7a01c",
      "lookupNationalIDType_Name": "India - Adhaar - English(USA)",
      "communalRegionCode": null,
      "communalRegionName": null,
      "spouseEarnsLessThanMinWage": false,
      "childTaxBenefitAllocatedToEmployee": 0,
      "isSingleParent": false,
      "numberOfChildrenOver3": 0,
      "numberOfChildrenUnder3": 0,
      "vacationAmount": null,
      "savingsAmount": null,
      "receiveEmails": false,
      "receivePostalMail": false,
      "receivePhoneCalls": false,
      "countryOfBirth_RecordID": null,
      "countryOfBirth": "",
      "canEditNationalID": true,
      "nationalID": "900897",
      "canEditMaritalStatus": true,
      "canEditDisabled": true,
      "canEditMedicareEligible": true,
      "canEditPassportID": true,
      "canEditTaxID": true,
      "preferredEmail": null,
      "salaryBandLevel": "Band 1",
      "grossEarnings": null,
      "grossEarningsFrequency": null,
      "grossEarningsCurrency_RecordID": null,
      "grossEarningsCurrencyCode": null,
      "canEditNationalIDType": true,
      "dob": "1990-01-01T00:00:00",
      "governmentID": "900897",
      "employeeID": "21447",
      "employeeNumberID": "800797",
      "payrollID": "",
      "systemID": null,
      "otherID": null,
      "workEmail": null,
      "personalEmail": null,
      "dateOfHire": null,
      "firstName": "QA",
      "lastName": "Membersite_Olb",
      "isEmployeeCreated": false,
      "citizenshipCountry_RecordID":"test",
      "dOB":"test",
      "businessUnit":"test"
  };
    this.enableRelatedPathCta('/profile', 'aboutme');
    this.componentRef = component;
  }

}
